import React, { useState, useEffect, useRef } from "react";
import { Search, MapPin, Star, Phone, MessageCircle, ChevronRight, X, Check,
  Sparkles, ArrowLeft, ShieldCheck, Plus, Building2, Upload, Mail, LogOut,
  Users, Clock, CreditCard, Zap, CheckCircle, XCircle, Briefcase, MessageSquare } from "lucide-react";



// ---
const LOGO = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAhCAYAAACfiCi5AAALLElEQVR42rVYa3Bd1XX+1t77nPvSw44s"
  + "CT/Blo1BFtgQcFy7RYbmQRLzSucW15hA0pQOecwwgclMmiaumiEDnaHTcd4JCebhR5CT4iYu5hGCCnET"
  + "nDrClmRsK7YlS5YlWZbkq/s6Z++1+uNcIdFQLJmw/9w7e87ee317fWutb21gumMTFDY1GmyCenMundYA"
  + "ULdxxeoFn1p+ZN7G+sUA6C3fvEdj+gc0gdHUYtEELhlOGBggACgy/7V4aglbfAqA4OXG9xwATevmm8B1"
  + "G1esDo1spKLb3LW97Y3IA9D19Wl99lB7B3m0CE56q4257MBTB7KlM+S9AqCn/mmjRlcXpxpqPoe4uS8M"
  + "7F0VV9boysti+841nwvK5sVXs+b7xdpQ+3pmnrk1c3CwA42NBitXEtIdhLUg1EChulHjkksU7u4CWt4d"
  + "ADPdBcxyiPJFK8xJ8vXXmWasv/iOqs+HXLiFPAVYxSKAMP09gGa0tNg/3qXlLT9IpzWam/lCPDV1ADU1"
  + "AgCeUt2hiCGI5cCGyuhlodhfiaCIgIUIvoTMpNXamg1LFl255PLCkePd/+qcqxKRGBGyINWjFb3uKd57"
  + "bMvB/dLc7CbT9E8ZA4TGxohmNYMKA9Vcd/HI0lwxPACSaK0Ig0gBRASIRHOWYsZDwA/3PvD4Vxdt/ruB"
  + "QIIZYsFkSCljAE9BQgsE/LpW6nveYO6xzj2dxZI33J8+iCeN2bdffhqaasUJE725h0zaj4UEWnnnFs6v"
  + "rHt1Z+DQ+VoIoADAYObs2TMbK9ckU/p2kLpFJQxsPmz1WD7fva3919MBQe+QXnnJhmsWFVV4v2NmRTIi"
  + "IqPENGbFNUGhBgIGEZXufRwGAyIUM8Y4Odb9RvyKRx+bvdwkzd35jDXaqN5U0uzbsOjWl4g+mY1/uG5+"
  + "dW3ia6z1Z4QZYu1n+rYd+hEaG83bx89UAJQWz7/jipuRMLtcIQQRgBJJOHQQgRBNtjuijtLKI6WgBE+e"
  + "3Np279ZX7vXPJo+3pqr0gmKOoTQBLCjmZIygdy5dUPuVD1f/+NTiu6+8KW/lx+LRLMrbe3p3dPxwKp6g"
  + "8+X9uesbviwG32Dr8oBoCIiI9OS1AmERgfY9rUV6raUv9O1o+/dHf/+J6wsofF/ILgmLLiClFUgELEQK"
  + "JlHhI8zhXDEr992/5tnH6u9avmLUybOiUauYr+95sq0FaWg0w11YDJRAzFnfsIl89U+uGIRAZDwRgQhg"
  + "ZkuaPNIaBnii+8m2e0Uk/+39675JHn9OhBEUrSNS6i0HEoQZTht48ZSHTL985YHrnv3Gkk9fdV3O2V9y"
  + "KF0zQ17R0dyRKzlYpl/IWiI6ZXbv+1VFfZVRvrlenLNEpEBgERHlG6NAvRLyJ3u3dTz0g9bb/mJv35bn"
  + "/XLcWMhax45FKa0iwDRxb0JEBCUiHAbMFVXmQ2tuqzvx9H2v/kdVfW0CZd7NeZahzMGBvWhsNOjq4gvN"
  + "QlEqbWmxc26vfxgx9SUObEBK+REj8HjPU233ikjhW/s/9i3ly2dZGGFeQqXIgACRKEFFAGQiaEQAEni+"
  + "Yscg33hZlzfLvr1lZHj03Nludm5s5qVY3NHUEU4OtelLia4uQTqtM0+3PF9ZX12pE/6fg+UUh3znqe0d"
  + "D/+g9bbr/vv0ludi5bgxP2adOAgBWgQgFV1TZDtNXFnpl5TCiy+N0DO7zjgdM4k5NX7q8Xte+NmMK2rm"
  + "q4T3wbBfPTd6sL8baWh0/DEANSURB8jF8Y5L59/R8MWe7e1fHB2wN/ZubV869NPDuzbv//jmUBd+CcVL"
  + "xoZtqIQURJQxQDwRGUwlBsuk2xcW+L7C8a48Wl4dQT4v+he7B6TrVHa9yKZkZsg2gyBCdi0AYKCRLkxK"
  + "dKQJaIaCmhtqPPKRr1+Lnf/4Z1uf3F93g0X4L/EyWZodDZ2AoEgZZobnEU73W5zLWFpcl4A2BGZAJCIT"
  + "SECRrkLMIxijUAwceR65ivfpil39B1eP7Bn6TdmdtQTBislSZvoASlrf13pmJhfK/Ev8R546cPQR9gAN"
  + "RnaYLZHSoMgg3yec6Aqw7elBymQcPrCyHJ+4eRbGTScALBCAwMxYMD+OW9ZVof3QGK5cViZz58aktyd/"
  + "LTD4oriaIoC5AID6Znl3Yi5KnrAhF6EkVsw5pyMFpCXiByCAMYI3juSQyzEqKwwOvZHF2F/OQCppoDSB"
  + "HYNDkFKQsTGB0g7vv6oMV19VBoHAOiFoXFQKEyuAV2qk5MI6spLrhHiIHVMm4wyJMAEKIAUSEJWkHBGs"
  + "JVy6JIFkSuHcmMNlS5NIJRVEBL2niigGglSZQTyuacfOM/j57iEwOxTyDkHA4ym29IeSJHS21DSpC/NA"
  + "yXUJTcdgORgYDH0W4Qn5pgASCEf8CAJg0cI4/vauagyPWNQtTIEUkM1aPPpYP+bN83HTjVU4eaqAYyfy"
  + "WLOqAkopEDkQCARILKZ6MXfxXJUw5HLh4YkgbrkAAJE+p1svurX7u0PNR/r6bUNmzEospmncaJQCExLl"
  + "+jAUzLkohnlz4wgCwFpGKmmwamU5XnxpBEc7e2GtoLbaYPWqclgnkSIXImGii2piv4tf4a2FIQjj1+9e"
  + "TpfE3YKNDQ+OhfIPt320Mrjm/eU6n2OlVCm3i0Ak0tZEACkiQEAqKmQEBWMEhzsLOH6igHhMSUN9AjNm"
  + "GFgrUAQhrZSwGlt39fJ5a27f/byKYUUsxILjO9r6ISDQhdQBAFjbwgCQSOkfkuXh1/aP+ZZJKzW+o0zI"
  + "OhJErY6UvEMAFARAaBn1SxO46WPvww1rK1FZaWBtFD9C5GIpD5Vl5tGr1/3ntbEZ3kqy2H58R1s/0mn9"
  + "dsZPHUCUAejI918/EffVUF9fmB06Y1+JJTWVrAaIQIreLFTMEs1LySMkICIUiozsGCOXFbArBT8I4qC5"
  + "6KR/MPxgxSzZFuZsIRYzDwKg/y+FTh1AOq0AyPwNy+8xlbHFhSw/tPLy6q8qrQAIc2RwxMlJgo1FZMI7"
  + "CgQVcR0QpSa0ETPDeKAwYPziuTMNRaZq5fhrx7a0HkU6/Y59Mk1RSmBVz6oZJ4vZI06cnN6auHjzvpoX"
  + "/BRWu9A6rZQSCIoFiahKb2lzUFKiVHrVkJKuAAuBSJBIKGSzTnY+M2SPHA/9pML2k9vaNkyloTm/mKtJ"
  + "K3yng3HZzId0ubn+9NHcX+39w/LLs2IfGB4sBKf7LQ60Z3lgoCi11b7yYwTnZEK8IZIRzNFNj3efRgPx"
  + "mAIRcOhwzv3kp2eod5BNyqPmmmTszr51fcB3OuT8UvkdqRN1Q4s2XtNQoGIrnGuv8OKfXnaV33xmOLik"
  + "91RI2YIgDAQigtoqjRvWVsrSS5OwVkr8J8TjCiixQITALJLJWOnuKfL/7M/qP5wMlCK4mEcPnnyifdMk"
  + "u84L4J3rQH20QeAK/0Y+abFYltX8u//67Rhs3jrPV52+0fvinnpZlNT39bvP7nlh2F+0MEmKAGUiEL/Z"
  + "N+JGRxkAKJ9jdXbEqcFhi0yWNawgEafdcTL/fPSJ11+bjvHnB1DSHwyEsJIXlsMuF/42ZfRer0rvmzNv"
  + "1tGWpomXg9nr61cJqdVBwLaiXOnAAs/sGpLWjrzRmiAMiBMoYNT4dCTp6ZdiSfezoz9qf23SC92U34Sm"
  + "LOaSw4VbCzWpWT1b23onzx8dPzTze4PyTgvBUBAKiATZHGP7zkE+0W11RUL/PObjexxKXmk6myrzTrV+"
  + "s3Xw/yYKNE3P+KkAEADo3NNZBND7ZlUeL25NEDQ3OzQ2EvZ0OvobNQIAfacDefmVUe7qcao8STu6F7bd"
  + "8TapMGpVa1oETZi24ePjfwFBIsnY8hOjdwAAAABJRU5ErkJggg=="
;
const ADMIN_EMAIL = "Admin@costamate.com";
const EMAILJS_SID = "service_6wkmxr2";
const EMAILJS_TID = "template_sb2a4k1";
const EMAILJS_KEY = "hd3w4I2DxgCF--MLK";
const STRIPE_URL = "https://buy.stripe.com/28E28qcBfdHedro9dw1wY03";
const VERIFY_FEE_URL = "https://buy.stripe.com/8x2fZg7gVbz6afc75o1wY04";


// ── CLOUDINARY ────────────────────────────────────────────
const CLOUDINARY_CLOUD = "eh18gvxn";
const CLOUDINARY_PRESET = "costamate";
const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/" + CLOUDINARY_CLOUD + "/image/upload";

async function uploadPhoto(file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", CLOUDINARY_PRESET);
  try {
    const res = await fetch(CLOUDINARY_URL, { method: "POST", body: formData });
    const data = await res.json();
    return data.secure_url || null;
  } catch(e) {
    console.error("Upload error:", e);
    return null;
  }
}

// ── API (Netlify Function) ────────────────────────────────
const API = "/.netlify/functions/api";

async function apiCall(action, data) {
  try {
    const res = await fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action, ...data }),
    });
    return await res.json();
  } catch(e) { console.error("API error:", e); return null; }
}

async function fbSaveCompany(company) {
  await apiCall("saveCompany", company);
}

async function fbGetCompanies() {
  const data = await apiCall("getCompanies", {});
  return Array.isArray(data) ? data : [];
}

async function fbUpdateCompany(id, updates) {
  await apiCall("updateCompany", { id, ...updates });
}

async function fbDeleteCompany(id) {
  await apiCall("deleteCompany", { id });
}

async function fbSaveQuote(quote) {
  // handled via email
}



// ---
// Navy #1B3A4B  Terracotta #C75D3A  Red #C0392B
// Cream #FAF6EF  Gold #F5C842  Green #2D9B6F
// Border #E4DCC8  Muted #9A9486  Body #6B6659

// ---
const TOWNS = ["Málaga","Torremolinos","Benalmádena","Fuengirola",
               "Mijas Costa","Marbella","San Pedro","Estepona"];

const TOWN_COORDS = {
  "Málaga":{lat:36.7213,lng:-4.4214},
  "Torremolinos":{lat:36.6205,lng:-4.5001},
  "Benalmádena":{lat:36.5985,lng:-4.5317},
  "Fuengirola":{lat:36.5369,lng:-4.6253},
  "Mijas Costa":{lat:36.5023,lng:-4.6573},
  "Marbella":{lat:36.5098,lng:-4.8822},
  "San Pedro":{lat:36.4870,lng:-5.0710},
  "Estepona":{lat:36.4254,lng:-5.1457},
};

const PREVIEW_COMPANY = {
  id: "preview-001",
  name: "Costa Clean Pro",
  category: "home_garden",
  town: "Marbella",
  towns: ["Marbella","Fuengirola","Benalmádena"],
  status: "approved",
  email: "demo@costamate.com",
  phone: "+34 600 123 456",
  whatsapp: "+34600123456",
  blurb: "Professional cleaning service for villas and apartments. " +
    "English-speaking team, fully insured, references available.",
  services: ["Regular cleaning","Deep clean","End of tenancy","Airbnb turnaround","Window cleaning"],
  priceFrom: "From €60",
  rating: 4.8,
  emergency: false,
  sponsored: true,
  photos: [],
  submittedAt: new Date().toISOString(),
};

const CATEGORIES = [
  {id:"home_garden",label:"Home & Garden",color:"#2D9B6F",icon:"🏡",
   subs:["Cleaning","Pool care","Gardening","Pest control","Handyman"]},
  {id:"trades",label:"Trades",color:"#E07B39",icon:"🔧",
   subs:["Plumbing","Electrical","Aircon","Building","Painting"]},
  {id:"vehicles",label:"Vehicles",color:"#4A7FB5",icon:"🚗",
   subs:["Mechanic","Car sales","ITV / MOT","Towing","Car hire"]},
  {id:"health",label:"Health & Beauty",color:"#9B59B6",icon:"🦷",
   subs:["Dentist","Doctor","Physio","Hair","Beauty"]},
  {id:"legal",label:"Legal & Financial",color:"#C0392B",icon:"⚖️",
   subs:["Lawyer","Gestor","Accountant","Mortgages","Wills"]},
  {id:"animals",label:"Animals",color:"#1ABC9C",icon:"🐾",
   subs:["Vet","Dog grooming","Pet sitting","Training"]},
  {id:"realestate",label:"Real Estate",color:"#E67E22",icon:"🏠",
   subs:["Property sales","Rentals","Property management","Valuations","New builds"]},
  {id:"moving",label:"Moving & Storage",color:"#E74C3C",icon:"📦",
   subs:["Removals","Storage","Packing","Man & van"]},
  {id:"lifestyle",label:"Lifestyle",color:"#8E44AD",icon:"💪",
   subs:["Personal trainer","Yoga","Swimming","Music lessons"]},
];

// ---
const TERMS_DATA = [
  ["1. About CostaMate",
    "CostaMate is operated by Prima Training Limited "
    + "(Companies House 05238520, VAT GB307847583). Contact: Admin@costamate.com."],
  ["2. Introduction service only",
    "CostaMate connects residents with independent local companies. "
    + "We are not a party to any contract between a resident and a company "
    + "and accept no responsibility for services carried out."],
  ["3. No contract with CostaMate",
    "Any contract for services is made directly between you and the company. "
    + "CostaMate accepts no liability for performance, quality or outcome."],
  ["4. Vetting",
    "We carry out basic checks before listing companies. "
    + "This does not constitute an endorsement or guarantee. "
    + "Always obtain a written quote before work commences."],
  ["5. Limitation of liability",
    "Prima Training Limited shall not be liable for any loss arising from "
    + "services, disputes or use of this platform. "
    + "Our total liability shall not exceed £100."],
  ["6. Emergency services",
    "The emergency feature sends messages to listed companies on your behalf. "
    + "CostaMate does not guarantee response times. "
    + "For life-threatening emergencies always call 112."],
  ["7. Your responsibilities",
    "You must be 18 or over. You must not submit false reviews "
    + "or misuse the platform."],
  ["8. Company listings",
    "Listed companies are independent businesses, "
    + "not employees or partners of Prima Training Limited. "
    + "We reserve the right to remove any listing at any time."],
  ["9. Reviews",
    "Reviews represent personal opinions. "
    + "By submitting a review you confirm it is truthful and not defamatory."],
  ["10. Payments",
    "Browsing is free for residents. "
    + "Company listing fees are subject to separate terms. "
    + "Payments are processed via Stripe."],
  ["11. Governing law",
    "These terms are governed by the laws of England and Wales."],
  ["12. Contact",
    "Admin@costamate.com · Prima Training Limited "
    + "· Companies House 05238520 · VAT GB307847583"],
];

const PRIVACY_DATA = [
  ["Who we are",
    "CostaMate is operated by Prima Training Limited (Companies House 05238520). "
    + "We are the data controller for information collected through this platform."],
  ["What we collect",
    "Email addresses, names, phone numbers and enquiry content "
    + "submitted through quote requests and account registration."],
  ["How we use it",
    "To connect residents with companies, send confirmation emails "
    + "and improve the service. We do not sell your data."],
  ["Your rights",
    "You may request deletion of your data by emailing Admin@costamate.com. "
    + "We will respond within 30 days."],
  ["Cookies",
    "We use essential cookies only to remember your preferences. "
    + "No advertising or tracking cookies."],
];

const CONTACT_SUBJECTS = [
  "General enquiry", "List my company", "Problem with a company",
  "Technical issue", "Press / partnership", "Other",
];

function sendEmail(params) {
  fetch("/.netlify/functions/api", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "sendEmail", ...params }),
  }).then(r => console.log("Email sent:", params.subject, r.status))
    .catch(e => console.error("Email error:", e));
}

function useLocal(key, def) {
  const [val, setVal] = useState(() => {
    try { const s = localStorage.getItem(key); return s ? JSON.parse(s) : def; }
    catch { return def; }
  });
  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
  }, [val, key]);
  return [val, setVal];
}

function timeAgo(ts) {
  if (!ts) return "";
  const d = Math.floor((Date.now() - new Date(ts)) / 86400000);
  if (d < 1) return "Today";
  if (d === 1) return "Yesterday";
  return d + " days ago";
}

// ---
function Topbar({ onBack, title, right, light, onAdmin }) {
  return (
    <header className={"topbar" + (light ? " topbar-light" : "")}>
      <div className="topbar-inner">
        {onBack
          ? <button className="tb-back" onClick={onBack}><ArrowLeft size={18} strokeWidth={2} /></button>
          : <span className="tb-gap" />}
        {title
          ? <span className="tb-title">{title}</span>
          : <div className="tb-brand" onClick={() => {
              const n = (parseInt(sessionStorage.getItem('tap')||0)+1);
              sessionStorage.setItem('tap', n);
              if (n >= 5) { sessionStorage.setItem('tap',0); if(onAdmin) onAdmin(); }
            }}>
              <img src={LOGO} alt="" className="tb-logo" />
              <span className="tb-word">Costa<span className="tb-mate">Mate</span></span>
            </div>}
        <div className="tb-right">{right || <span />}</div>
      </div>
    </header>
  );
}

function Btn({ children, onClick, variant, full, disabled, href }) {
  const cls = "btn btn-" + (variant || "primary") + (full ? " btn-full" : "");
  if (href) return <a className={cls} href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
  return <button className={cls} onClick={onClick} disabled={disabled}>{children}</button>;
}

function FieldLabel({ children, sub }) {
  return <label className="field-label">{children}{sub && <span className="field-sub"> {sub}</span>}</label>;
}

function Field({ label, sub, children }) {
  return (
    <div className="field">
      {label && <FieldLabel sub={sub}>{label}</FieldLabel>}
      {children}
    </div>
  );
}

function PhoneInput({ value, onChange }) {
  const CODES = [
    {c:"+34",f:"🇪🇸",n:"Spain"},{c:"+44",f:"🇬🇧",n:"UK"},
    {c:"+353",f:"🇮🇪",n:"Ireland"},{c:"+1",f:"🇺🇸",n:"USA"},
    {c:"+61",f:"🇦🇺",n:"Australia"},{c:"+27",f:"🇿🇦",n:"South Africa"},
    {c:"+49",f:"🇩🇪",n:"Germany"},{c:"+33",f:"🇫🇷",n:"France"},
    {c:"+31",f:"🇳🇱",n:"Netherlands"},{c:"+64",f:"🇳🇿",n:"New Zealand"},
  ];
  const [code, setCode] = useState("+34");
  const [num, setNum] = useState("");
  const [open, setOpen] = useState(false);
  useEffect(() => { onChange(num ? code + " " + num : ""); }, [code, num]);
  useEffect(() => {
    if (value) {
      const m = CODES.find(c => value.startsWith(c.c));
      if (m) { setCode(m.c); setNum(value.slice(m.c.length).trim()); }
      else setNum(value);
    }
  }, []);
  const sel = CODES.find(c => c.c === code) || CODES[0];
  return (
    <div className="phone-wrap">
      <button type="button" className="phone-code-btn" onClick={() => setOpen(o => !o)}>
        {sel.f} {sel.c}
      </button>
      <input className="phone-num-input" type="tel" placeholder="600 000 000"
        value={num} onChange={e => setNum(e.target.value)} />
      {open && (
        <div className="phone-dropdown">
          {CODES.map(c => (
            <button key={c.c} type="button" className={"phone-opt" + (c.c === code ? " active" : "")}
              onClick={() => { setCode(c.c); setOpen(false); }}>
              {c.f} {c.n} <span>{c.c}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// ---
function AuthScreen({ onAuthed, onBack, admin }) {
  const [mode, setMode] = useState("signin");
  const [email, setEmail] = useState(admin ? ADMIN_EMAIL : "");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const [newPw, setNewPw] = useState("");
  const [resetDone, setResetDone] = useState(false);

  const sendReset = () => {
    if (!resetEmail.includes("@")) { setErr("Enter a valid email."); return; }
    const code = Math.floor(100000 + Math.random() * 900000).toString();
    localStorage.setItem("cm:reset:" + resetEmail.toLowerCase(), JSON.stringify({code, exp: Date.now() + 15*60*1000}));
    sendEmail({
      to_email: resetEmail,
      subject: "CostaMate — your password reset code",
      message: "Your reset code is: " + code + "\n\nThis code expires in 15 minutes.\n\nIf you didn't request this, ignore this email.\n\nThe CostaMate team",
      from_name: "CostaMate"
    });
    setResetSent(true);
    setErr("");
  };

  const confirmReset = () => {
    const stored = localStorage.getItem("cm:reset:" + resetEmail.toLowerCase());
    if (!stored) { setErr("No reset request found. Try again."); return; }
    const {code, exp} = JSON.parse(stored);
    if (Date.now() > exp) { setErr("Code expired. Request a new one."); return; }
    if (resetCode !== code) { setErr("Incorrect code."); return; }
    if (newPw.length < 6) { setErr("Password must be 6+ characters."); return; }
    const key = "cm:acc:" + resetEmail.toLowerCase().replace(/[^a-z0-9@._-]/g,"");
    const acc = JSON.parse(localStorage.getItem(key) || "{}");
    localStorage.setItem(key, JSON.stringify({...acc, email:resetEmail.toLowerCase(), pw:btoa(newPw)}));
    localStorage.removeItem("cm:reset:" + resetEmail.toLowerCase());
    setResetDone(true);
    setErr("");
  };

  if (resetMode) return (
    <div className="auth-screen">
      {onBack && <button className="auth-back-btn" onClick={onBack}><ArrowLeft size={16} strokeWidth={2} /> Back</button>}
      <div className="auth-logo">
        <img src={LOGO} alt="" className="tb-logo" />
        <span className="auth-wordmark">Costa<span className="tb-mate">Mate</span></span>
      </div>
      <h1 className="auth-title">Reset password</h1>
      {resetDone ? (
        <>
          <p style={{fontSize:14,color:"#2D9B6F",textAlign:"center",marginBottom:16}}>✓ Password updated! You can now sign in.</p>
          <Btn full onClick={() => { setResetMode(false); setMode("signin"); }}>Sign in</Btn>
        </>
      ) : (
        <>
          <p style={{fontSize:13,color:"#6B6659",marginBottom:12,textAlign:"center"}}>Enter your email and choose a new password.</p>
          <Field label="Your email">
            <input className="input" type="email" value={resetEmail} onChange={e=>setResetEmail(e.target.value)} />
          </Field>
          <Field label="New password">
            <input className="input" type="password" value={newPw} onChange={e=>setNewPw(e.target.value)} placeholder="At least 6 characters" />
          </Field>
          {err && <p className="err">{err}</p>}
          <Btn full onClick={async () => {
            if (!resetEmail.includes("@")) { setErr("Enter a valid email."); return; }
            if (newPw.length < 6) { setErr("Password must be at least 6 characters."); return; }
            const key = "cm:acc:" + resetEmail.toLowerCase().replace(/[^a-z0-9@._-]/g,"");
            let found = false;
            // Check localStorage
            const existing = localStorage.getItem(key);
            if (existing) {
              const acc = JSON.parse(existing);
              localStorage.setItem(key, JSON.stringify({...acc, pw:btoa(newPw)}));
              found = true;
            }
            // Check and update Airtable
            try {
              const atAcc = await apiCall("getAccount", {email: resetEmail.toLowerCase()});
              if (atAcc && atAcc.email) {
                apiCall("updateAccount", {email: resetEmail.toLowerCase(), pw: btoa(newPw)});
                if (!found) localStorage.setItem(key, JSON.stringify({email:resetEmail.toLowerCase(), pw:btoa(newPw)}));
                found = true;
              }
            } catch {}
            if (!found) { setErr("No account found with that email."); return; }
            setResetDone(true);
            setErr("");
          }}>Set new password</Btn>
        </>
      )}
      <p className="auth-switch"><button onClick={() => setResetMode(false)}>Back to sign in</button></p>
    </div>
  );

  const submit = async () => {
    setErr("");
    if (!email.includes("@")) { setErr("Enter a valid email."); return; }
    if (pw.length < 6) { setErr("Password must be 6+ characters."); return; }
    if (admin && (email.toLowerCase() !== ADMIN_EMAIL.toLowerCase() || pw !== "Bananas1979!")) {
      setErr("Invalid credentials."); return;
    }
    if (admin) { setLoading(false); onAuthed({email:ADMIN_EMAIL}); return; }
    setLoading(true);
    const key = "cm:acc:" + email.toLowerCase().replace(/[^a-z0-9@._-]/g,"");
    try {
      if (mode === "signup") {
        let ex = null;
        try { const s = localStorage.getItem(key); ex = s ? JSON.parse(s) : null; } catch {}
        if (ex) { setErr("Account already exists. Sign in instead."); setLoading(false); return; }
        // Check Airtable too
        try {
          const atAcc = await apiCall("getAccount", {email: email.toLowerCase()});
          if (atAcc && atAcc.email) { setErr("Account already exists. Sign in instead."); setLoading(false); return; }
        } catch {}
        const accData = {email:email.toLowerCase(), pw:btoa(pw)};
        localStorage.setItem(key, JSON.stringify(accData));
        // Save to Airtable
        apiCall("saveAccount", {email: email.toLowerCase(), pw: btoa(pw)});
        apiCall("saveMember", {
          email: email.toLowerCase(),
          signupAt: new Date().toISOString(),
          town: localStorage.getItem("cm:town") ? JSON.parse(localStorage.getItem("cm:town")) : null,
        });
        sendEmail({to_email:email, subject:"Welcome to CostaMate",
          message:"Welcome! Your account is active. Let's get you sorted.\n\nThe CostaMate team",
          from_name:"CostaMate"});
        sendEmail({to_email:ADMIN_EMAIL, subject:"New resident signup — "+email,
          message:"New resident signed up: "+email+
            "\n\nTime: "+new Date().toLocaleString("en-GB",{timeZone:"Europe/Madrid"}),
          from_name:"CostaMate"});
        onAuthed({email:email.toLowerCase()});
      } else {
        // Check localStorage first
        let acc = null;
        try { const s = localStorage.getItem(key); acc = s ? JSON.parse(s) : null; } catch {}
        // If not found locally, check Airtable
        if (!acc) {
          try {
            const atAcc = await apiCall("getAccount", {email: email.toLowerCase()});
            if (atAcc && atAcc.email) {
              acc = atAcc;
              // Cache locally
              localStorage.setItem(key, JSON.stringify(acc));
            }
          } catch {}
        }
        if (!acc) { setErr("No account found. Create one first."); setLoading(false); return; }
        if (acc.pw !== btoa(pw)) { setErr("Incorrect password."); setLoading(false); return; }
        onAuthed({email:acc.email});
      }
    } catch { onAuthed({email:email.toLowerCase()}); }
    setLoading(false);
  };

  return (
    <div className="auth-screen">
      {onBack && <button className="auth-back-btn" onClick={onBack}><ArrowLeft size={16} strokeWidth={2} /> Back</button>}
      <div className="auth-logo">
        <img src={LOGO} alt="" className="tb-logo" />
        <span className="auth-wordmark">
          Costa<span className="tb-mate">Mate</span>
        </span>
      </div>
      <h1 className="auth-title">{admin ? "Admin login" : mode === "signup" ? "Create account" : "Sign in"}</h1>
      <Field label="Email">
        <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} />
      </Field>
      <Field label="Password">
        <input className="input" type="password" value={pw} onChange={e => setPw(e.target.value)} />
      </Field>
      {err && <p className="err">{err}</p>}
      <Btn full onClick={submit} disabled={loading}>{loading ? "Please wait..." : mode === "signup" ? "Create account" : "Sign in"}</Btn>
      {!admin && (
        <p className="auth-switch">
          {mode === "signin"
            ? <span>New? <button onClick={() => { setMode("signup"); setErr(""); }}>Create an account</button></span>
            : <span>Have an account? <button onClick={() => { setMode("signin"); setErr(""); }}>Sign in</button></span>}
        </p>
      )}
      {!admin && mode === "signin" && (
        <p className="auth-switch"><button onClick={() => { setResetMode(true); setResetEmail(email); setErr(""); }}>Forgot password?</button></p>
      )}
    </div>
  );
}

// ---
function SplashScreen({ onHelp, onEmergency, onPortal, onAdmin, onAbout, onTerms, onPrivacy, onContact, onDemoName }) {
  return (
    <div className="splash">
      <div className="splash-hero">
        <div className="splash-orb splash-orb1" />
        <div className="splash-orb splash-orb2" />
        <div className="splash-top">
          <div className="tb-brand">
            <img src={LOGO} alt="" className="tb-logo" />
            <span className="tb-word">Costa<span className="tb-mate">Mate</span></span>
          </div>
        </div>
        <button className="splash-stamp" onClick={onAbout}>
          <svg className="stamp-ring" viewBox="0 0 160 160">
            <circle cx="80" cy="80" r="72" fill="none" stroke="rgba(245,200,66,0.35)" strokeWidth="1.5" strokeDasharray="6 4" />
            <circle cx="80" cy="80" r="64" fill="none" stroke="#F5C842" strokeWidth="2" />
          </svg>
          <div className="stamp-inner">
            <ShieldCheck size={22} strokeWidth={1.5} color="#F5C842" />
            <span className="stamp-name">CostaMate</span>
            <span className="stamp-tag">VETTED & VERIFIED</span>
            <span className="stamp-sub">EVERY COMPANY CHECKED</span>
          </div>
        </button>
        <p className="splash-tagline">Let's get it sorted.</p>
      </div>
      <div className="splash-ctas">
        <button className="cta-emergency" onClick={onEmergency}>
          <div className="cta-icon"><Zap size={18} strokeWidth={2} /></div>
          <div className="cta-text"><strong>I need help right now</strong><span>24hr emergency companies</span></div>
          <ChevronRight size={16} strokeWidth={2.5} />
        </button>
        <button className="cta-main" onClick={onHelp}>
          <strong>I need help!</strong>
          <span>Let's get it sorted.</span>
        </button>
        <button className="cta-portal" onClick={onPortal}>
          <Building2 size={14} strokeWidth={2} /> List your company free
        </button>
        <div className="splash-footer">
          <button onClick={onTerms}>Terms</button>
          <span>·</span>
          <button onClick={onPrivacy}>Privacy</button>
          <span>·</span>
          <button onClick={onContact}>Contact</button>
          <span>·</span>
          <button onClick={onAdmin}>Admin</button>
        </div>
        <div className="demo-bar">
          <span className="demo-label">Demo a company:</span>
          <input className="demo-input" placeholder="Type company name..."
            defaultValue=""
            onChange={e => onDemoName(e.target.value || null)} />
        </div>
      </div>
    </div>
  );
}

// ---
function WelcomeBack({ town, user, onHelp, onEmergency, onChangeTown, onPortal, onAdmin, onContact, onAbout, onSignIn, onForBusiness, onCategory }) {
  const hr = new Date().getHours();
  const greet = hr < 12 ? "Good morning" : hr < 18 ? "Good afternoon" : "Good evening";
  const name = user && user.name ? user.name.split(" ")[0] : null;
  return (
    <div className="wb">
      <div className="wb-hero">
        <div className="wb-orb wb-orb1" /><div className="wb-orb wb-orb2" />
        <div className="wb-top">
          <div className="tb-brand">
            <img src={LOGO} alt="" className="tb-logo" />
            <span className="tb-word" style={{color:"#FAF6EF"}}>Costa<span style={{color:"#F5C842"}}>Mate</span></span>
          </div>
          <button className="wb-town-pill" onClick={onChangeTown}>
            <MapPin size={11} strokeWidth={2} /> {town}
          </button>
        </div>
        <div className="wb-greeting">
          <p className="wb-hello">{greet}{name ? ", " + name : ""}.</p>
          <h1 className="wb-title">Welcome back.</h1>
          <p className="wb-sub">How can we help you today?</p>
          <p className="wb-tagline">Let's get it sorted.</p>
          <div className="wb-tiles">
            {CATEGORIES.slice(0,4).map(c => (
              <button key={c.id} className="wb-tile" onClick={() => onCategory ? onCategory(c.id) : onHelp()}>
                <div className="wb-tile-icon" style={{background:"rgba(245,200,66,0.15)"}}>
                  <span style={{fontSize:30}}>{c.icon}</span>
                </div>
                <span>{c.label}</span>
              </button>
            ))}
          </div>
          <button className="wb-see-all" onClick={onHelp}>See all services →</button>
        </div>
      </div>
      <div className="wb-actions">
        <button className="cta-emergency" onClick={onEmergency}>
          <div className="cta-icon"><Zap size={18} strokeWidth={2} /></div>
          <div className="cta-text"><strong>I need help right now</strong><span>24hr emergency companies</span></div>
          <ChevronRight size={15} strokeWidth={2.5} />
        </button>
        <button className="cta-portal" onClick={onPortal}>
          <Building2 size={14} strokeWidth={2} /> List your company free
        </button>
        <div className="wb-footer">
          <button onClick={onSignIn}>{user ? "👤 " + (user.name ? user.name.split(" ")[0] : "My account") : "Sign in"}</button>
          <span>·</span>
          <button onClick={onForBusiness}>For Business</button>
          <span>·</span>
          <button onClick={onContact}>Contact</button>
          <span>·</span>
          <button onClick={onAbout}>About</button>
          <span>·</span>
          <button onClick={onAdmin}>Admin</button>
        </div>
      </div>
    </div>
  );
}

// ---
function distKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2)*Math.sin(dLat/2) +
    Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*
    Math.sin(dLng/2)*Math.sin(dLng/2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

const RADIUS_OPTIONS = [5, 10, 20, 50, 150];
const RADIUS_LABELS  = ["5km","10km","20km","50km","Whole coast"];


function LocationPicker({ onSelect, onBack, emergency }) {
  const [status, setStatus] = useState("idle");
  const [coords, setCoords] = useState(null);
  const [radiusIdx, setRadiusIdx] = useState(1); // default 10km
  const [manualTown, setManualTown] = useState(null);

  const nearestTown = (lat, lng) => {
    return TOWNS.reduce((best, t) => {
      const c = TOWN_COORDS[t];
      if (!c) return best;
      const d = distKm(lat, lng, c.lat, c.lng);
      return (!best || d < best.d) ? {t, d} : best;
    }, null)?.t || "Costa del Sol";
  };

  const requestGPS = () => {
    if (!navigator.geolocation) { setStatus("denied"); return; }
    setStatus("requesting");
    navigator.geolocation.getCurrentPosition(
      pos => {
        const { latitude: lat, longitude: lng } = pos.coords;
        setCoords({ lat, lng });
        setStatus("found");
      },
      () => setStatus("denied"),
      { timeout: 8000, enableHighAccuracy: true }
    );
  };

  React.useEffect(() => { requestGPS(); }, []);

  const confirm = () => {
    const radius = RADIUS_OPTIONS[radiusIdx];
    if (coords) {
      const town = nearestTown(coords.lat, coords.lng);
      onSelect({ lat: coords.lat, lng: coords.lng, town, radius });
    } else if (manualTown) {
      const c = TOWN_COORDS[manualTown];
      onSelect({ lat: c.lat, lng: c.lng, town: manualTown, radius });
    }
  };

  // Requesting GPS
  if (status === "requesting") return (
    <div className="screen loc-screen">
      {onBack && <button className="loc-back" onClick={onBack}>
        <ArrowLeft size={18} strokeWidth={2} />
      </button>}
      <div className="loc-body">
        <div className="loc-icon loc-icon-spin">
          <MapPin size={32} strokeWidth={1.5} color="#1B3A4B" />
        </div>
        <h2 className="loc-title">Finding your location...</h2>
        <p className="loc-sub">Please allow location access when prompted.</p>
      </div>
    </div>
  );

  // GPS found — show radius picker
  if (status === "found" && coords) return (
    <div className="screen">
      <Topbar onBack={onBack}
        title={emergency ? "Your location" : "Set your search area"} light />
      <div className="radius-body">
        <div className="radius-found-row">
          <MapPin size={16} strokeWidth={2} color="#2D9B6F" />
          <span>Located near <strong>{nearestTown(coords.lat, coords.lng)}</strong></span>
        </div>
        <h2 className="radius-title">How far should we search?</h2>
        <p className="radius-sub">
          We'll show you companies within this distance.
        </p>
        <div className="radius-options">
          {RADIUS_OPTIONS.map((r, i) => (
            <button key={r}
              className={"radius-btn" + (radiusIdx === i ? " radius-btn-on" : "")}
              onClick={() => setRadiusIdx(i)}>
              <span className="radius-km">{RADIUS_LABELS[i]}</span>
              <span className="radius-desc">
                {i === 0 ? "Very local" :
                 i === 1 ? "Nearby" :
                 i === 2 ? "Town & surrounds" :
                 i === 3 ? "Wide area" :
                 "Entire Costa del Sol"}
              </span>
            </button>
          ))}
        </div>
        <Btn full onClick={confirm}>
          Show companies within {RADIUS_LABELS[radiusIdx]}
        </Btn>
        <button className="radius-manual-link"
          onClick={() => setStatus("denied")}>
          Choose area manually instead
        </button>
      </div>
    </div>
  );

  // Manual fallback
  return (
    <div className="screen">
      <Topbar onBack={onBack}
        title={emergency ? "Where are you?" : "Choose your area"} light />
      <div className="loc-manual-body">
        {status === "denied" && (
          <div className="loc-denied-banner">
            <MapPin size={14} strokeWidth={2} />
            <span>Location access denied — no problem, just pick your nearest town below.</span>
          </div>
        )}
        {status !== "denied" && (
          <button className="use-location-btn" onClick={requestGPS}>
            <MapPin size={16} strokeWidth={2} /> Use my location instead
          </button>
        )}
        <p className="location-or">{status === "denied" ? "Select your nearest town:" : "or pick your nearest town"}</p>
        <div className="town-grid">
          {TOWNS.map(t => (
            <button key={t}
              className={"town-btn" + (manualTown === t ? " town-btn-sel" : "")}
              onClick={() => setManualTown(t)}>
              {t}
            </button>
          ))}
          <button
            className={"town-btn town-btn-other" + (manualTown === "Costa del Sol" ? " town-btn-sel" : "")}
            onClick={() => setManualTown("Costa del Sol")}>
            Other area
          </button>
        </div>
        {manualTown && (
          <>
            <p className="radius-title" style={{marginTop:24,fontSize:16}}>
              How far should we search?
            </p>
            <div className="radius-options">
              {RADIUS_OPTIONS.map((r, i) => (
                <button key={r}
                  className={"radius-btn" + (radiusIdx === i ? " radius-btn-on" : "")}
                  onClick={() => setRadiusIdx(i)}>
                  <span className="radius-km">{RADIUS_LABELS[i]}</span>
                  <span className="radius-desc">
                    {i === 0 ? "Very local" : i === 1 ? "Nearby" :
                     i === 2 ? "Town & surrounds" : i === 3 ? "Wide area" :
                     "Entire Costa del Sol"}
                  </span>
                </button>
              ))}
            </div>
            <Btn full onClick={confirm}>
              Show companies within {RADIUS_LABELS[radiusIdx]}
            </Btn>
          </>
        )}
      </div>
    </div>
  );
}

function BrowseScreen({ companies, town, userCoords, searchRadius, onRadiusChange, onChangeTown, onBack, onCompany, onSignIn, user }) {
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState(null);
  const [sortBy, setSortBy] = useState('rating');
  const [mapView, setMapView] = useState(false);
  const [emergency, setEmergency] = useState(false);
  const [history, setHistory] = useLocal("cm:history", []);

  const companyInRange = (c) => {
    if (!userCoords || (searchRadius || 10) >= 150) return true;
    const base = c.baseTown || (c.towns && c.towns[0]) || c.town;
    const cCoords = base ? TOWN_COORDS[base] : null;
    if (!cCoords) return true;
    const gap = distKm(userCoords.lat, userCoords.lng, cCoords.lat, cCoords.lng);
    const reach = (c.coverageRadius || 20);
    return gap <= ((searchRadius || 10) + reach);
  };

  const approved = (companies||[]).filter(c => c.status === "approved" && companyInRange(c));
  const getDistance = (c) => {
    if (!userCoords || !c.lat || !c.lng) return null;
    const dLat = (c.lat - userCoords.lat) * Math.PI / 180;
    const dLng = (c.lng - userCoords.lng) * Math.PI / 180;
    const a = Math.sin(dLat/2)*Math.sin(dLat/2) +
      Math.cos(userCoords.lat*Math.PI/180)*Math.cos(c.lat*Math.PI/180)*
      Math.sin(dLng/2)*Math.sin(dLng/2);
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  };

  const sorted = (list) => {
    const sort = (a, b) => {
      // Featured always first
      if (a.featured && !b.featured) return -1;
      if (!a.featured && b.featured) return 1;
      if (sortBy === 'distance' && userCoords)
        return (getDistance(a)||999)-(getDistance(b)||999);
      if (sortBy === 'newest')
        return new Date(b.submittedAt||0)-new Date(a.submittedAt||0);
      return (b.rating||0)-(a.rating||0);
    };
    return [...list].sort(sort);
  };

  const filtered = sorted(approved.filter(c => {
    if (category && c.category !== category) return false;
    if (emergency && !c.emergency) return false;
    if (query) {
      const q = query.toLowerCase();
      const services = (c.services||[]).join(" ").toLowerCase();
      return (c.name||"").toLowerCase().includes(q) ||
             (c.blurb||"").toLowerCase().includes(q) ||
             services.includes(q);
    }
    return true;
  }));

  const addHistory = (cat) => {
    const entry = {town:town, category:cat, date:new Date().toISOString()};
    setHistory(prev => [entry, ...prev.filter(h => !(h.town===town&&h.category===cat))].slice(0,10));
  };

  const getAccountBtn = () => {
    if (user) {
      return (
        <button className="tb-account-btn" onClick={onSignIn}>
          <span className="tb-avatar">{(user.name||user.email)[0].toUpperCase()}</span>
        </button>
      );
    }
    return (
      <button className="tb-account-btn" onClick={onSignIn}>
        <span>Sign in</span>
      </button>
    );
  };

  return (
    <div className="screen browse-screen">
      <Topbar onBack={onBack} right={getAccountBtn()} />
      <div className="town-bar">
        <div className="loc-pill-row">
          <MapPin size={12} strokeWidth={2} color="#2D9B6F" />
          <span className="loc-pill-text">
            {userCoords ? "Near " : ""}{town || "All areas"}
            {searchRadius && searchRadius < 150 ? " · " + searchRadius + "km" : ""}
          </span>
          <button className="loc-pill-change" onClick={onChangeTown}>Change</button>
        </div>
      </div>
      <div className="search-bar">
        <Search size={16} strokeWidth={2} className="search-icon" />
        <input className="search-input" placeholder="Search services or companies..."
          value={query} onChange={e => setQuery(e.target.value)} />
        {query && <button className="search-clear" onClick={() => setQuery("")}><X size={14} strokeWidth={2.5} /></button>}
      </div>

      {!query && !category ? (
        <div className="cat-grid">
          {CATEGORIES.map(c => (
            <button key={c.id} className="cat-tile" onClick={() => { setCategory(c.id); addHistory(c.id); }}>
              <div className="cat-tile-top" style={{background:c.color+"18"}}>
                <span className="cat-tile-emoji">{c.icon}</span>
              </div>
              <span>{c.label}</span>
            </button>
          ))}
        </div>
      ) : (
        <div className="results-area">
          {category && (
            <div className="results-header">
              <button className="results-back" onClick={() => setCategory(null)}>
                <ArrowLeft size={14} strokeWidth={2} /> Back
              </button>
              <span>{CATEGORIES.find(c=>c.id===category)?.label}</span>
              <span className="results-count">{filtered.length} companies</span>
            </div>
          )}
          {filtered.length === 0 ? (
            <div className="empty">
              <p className="empty-title">No companies found</p>
              <p className="empty-sub">Try a different search or browse all categories.</p>
              {query && <Btn onClick={() => setQuery("")} variant="secondary">Clear search</Btn>}
            </div>
          ) : (
            <div>
              <div className="filter-bar">
                <button className={"filter-chip"+(sortBy==="rating"?" filter-chip-on":"")}
                  onClick={()=>setSortBy("rating")}>Top rated</button>
                {userCoords && <button className={"filter-chip"+(sortBy==="distance"?" filter-chip-on":"")}
                  onClick={()=>setSortBy("distance")}>Nearest</button>}
                <button className={"filter-chip"+(sortBy==="newest"?" filter-chip-on":"")}
                  onClick={()=>setSortBy("newest")}>Newest</button>
                <button className={"filter-chip"+(emergency?" filter-chip-on":"")}
                  onClick={()=>setEmergency(e=>!e)}>24hr only</button>
                <button className={"filter-chip"+(mapView?" filter-chip-on":"")}
                  onClick={()=>setMapView(m=>!m)}>🗺 Map</button>
              </div>
              {mapView ? (
                <div className="map-view">
                  <p className="map-hint">Tap a company to open in Google Maps</p>
                  {filtered.filter(c => TOWN_COORDS[c.baseTown||c.town||(c.towns&&c.towns[0])]).map(c => {
                    const coords = TOWN_COORDS[c.baseTown||c.town||(c.towns&&c.towns[0])];
                    return (
                      <a key={c.id} className="map-company-row"
                        href={"https://www.google.com/maps/search/?api=1&query="+encodeURIComponent(c.name+", "+(c.baseTown||c.town||"Costa del Sol"))}
                        target="_blank" rel="noopener noreferrer">
                        <div className="map-pin">📍</div>
                        <div className="map-company-info">
                          <strong>{c.name}</strong>
                          <span>{c.baseTown||c.town||(c.towns&&c.towns[0])}</span>
                        </div>
                        {c.featured && <span className="cc-badge cc-badge-sp" style={{position:"static",fontSize:10}}>⭐</span>}
                      </a>
                    );
                  })}
                  {filtered.filter(c => !TOWN_COORDS[c.baseTown||c.town||(c.towns&&c.towns[0])]).length > 0 && (
                    <p style={{fontSize:12,color:"#9A9486",textAlign:"center",padding:"8px 0"}}>
                      {filtered.filter(c => !TOWN_COORDS[c.baseTown||c.town||(c.towns&&c.towns[0])]).length} companies without location data
                    </p>
                  )}
                </div>
              ) : (
                <div className="company-list">
                  {filtered.map(c => (
                    <CompanyCard key={c.id} company={c}
                      distance={getDistance(c)}
                      onOpen={() => onCompany(c)} />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function CompanyCard({ company:c, onOpen, distance }) {
  const isVetted = c.paid_verification && c.verified;
  return (
    <button className={"company-card" + (c.featured ? " company-card-featured" : "")} onClick={onOpen}>
      <div className="cc-photo">
        {c.photos?.[0]
          ? <img src={c.photos[0]} alt={c.name} />
          : <div className="cc-photo-placeholder"><Building2 size={24} strokeWidth={1.5} /></div>}
        {c.emergency && <span className="cc-badge cc-badge-em">24hr</span>}
        {c.featured && <span className="cc-badge cc-badge-sp">⭐ Featured</span>}
      </div>
      <div className="cc-info">
        <div className="cc-top">
          <strong className="cc-name">{c.name}</strong>
          {isVetted && <span className="cc-verified" title="Vetted and verified">✓ Vetted</span>}
          {c.rating && <span className="cc-rating"><Star size={11} fill="#F5C842" color="#F5C842" /> {c.rating.toFixed(1)}</span>}
        </div>
        <p className="cc-cat">
          {CATEGORIES.find(cat=>cat.id===c.category)?.label}
          {" · "}
          {(c.towns && c.towns.length > 1)
            ? c.towns.length + " areas"
            : c.town || (c.towns && c.towns[0])}
          {distance != null && <span className="cc-distance"> · 📍 {distance < 1 ? Math.round(distance*1000)+"m" : distance.toFixed(1)+"km"}</span>}
        </p>
        <p className="cc-blurb">{c.blurb}</p>
        {c.priceFrom && <p className="cc-price">From {c.priceFrom}</p>}
        {c.responseTime && <p className="cc-response">⚡ Responds {c.responseTime.toLowerCase()}</p>}
      </div>
    </button>
  );
}

function CompanyDetail({ company:c, onBack, onQuote, user, isFavourite, onToggleFavourite }) {
  return (
    <div className="screen">
      <Topbar onBack={onBack} title={c.name} light
        right={<button onClick={onToggleFavourite}
          style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:isFavourite?"#F5C842":"#C8BC9C",padding:"0 4px"}}>
          {isFavourite ? "★" : "☆"}
        </button>} />
      <div className="detail-body">
        {c.photos?.[0] && <img className="detail-photo" src={c.photos[0]} alt={c.name} />}
        <div className="detail-section">
          <div className="detail-top">
            <h1 className="detail-name">{c.name}</h1>
            {c.rating && <span className="detail-rating"><Star size={14} fill="#F5C842" color="#F5C842" /> {c.rating.toFixed(1)}</span>}
          </div>
          {(c.paid_verification && c.verified) && <div className="detail-verified"><ShieldCheck size={14} strokeWidth={2} color="#2D9B6F" /> Vetted &amp; verified by CostaMate</div>}
          {c.featured && <div className="detail-featured">⭐ Featured company</div>}
          {c.responseTime && <div className="detail-response">⚡ Usually responds {c.responseTime.toLowerCase()}</div>}
          <p className="detail-cat">{CATEGORIES.find(cat=>cat.id===c.category)?.label}</p>
          <p className="detail-blurb">{c.blurb}</p>
        </div>
        <div className="detail-actions">
          {c.phone && <a className="btn btn-secondary btn-full" href={"tel:"+c.phone}><Phone size={15} strokeWidth={2} /> Call</a>}
          {c.whatsapp && <a className="btn btn-wa btn-full" href={"https://wa.me/"+c.whatsapp.replace(/[^0-9]/g,"")}
            target="_blank" rel="noopener noreferrer"><MessageCircle size={15} strokeWidth={2} /> WhatsApp</a>}
          <Btn full onClick={onQuote}>Send a quote request</Btn>
          <a className="btn btn-secondary btn-full"
            href={"https://wa.me/?text="+encodeURIComponent("Check out "+c.name+" on CostaMate — "+c.blurb+" https://costamate.com")}
            target="_blank" rel="noopener noreferrer"
            style={{fontSize:13,textAlign:"center"}}>
            📤 Share this company
          </a>
        </div>
        {c.services?.length > 0 && (
          <div className="detail-section">
            <h3 className="detail-section-title">Services</h3>
            <div className="detail-services">
              {c.services.map((s,i) => <span key={i} className="service-tag">{s}</span>)}
            </div>
          </div>
        )}
        {(() => {
          try {
            const recs = JSON.parse(localStorage.getItem("cm:recs:" + c.id) || "[]");
            if (recs.length === 0) return null;
            return (
              <div className="detail-section">
                <h3 className="detail-section-title">Also recommended by {c.name}</h3>
                {recs.map(r => (
                  <div key={r.id} className="rec-card">
                    <Building2 size={16} strokeWidth={1.5} color="#1B3A4B" />
                    <div>
                      <strong>{r.name}</strong>
                      <span>{CATEGORIES.find(cat=>cat.id===r.category)?.label}</span>
                    </div>
                  </div>
                ))}
              </div>
            );
          } catch { return null; }
        })()}
      </div>
    </div>
  );
}

// ---
function QuoteModal({ company, onClose, userEmail, onSent }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState(userEmail || "");
  const [phone, setPhone] = useState("");
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const send = () => {
    if (!name || !email || !msg) return;
    setSending(true);
    sendEmail({
      to_email: company.email,
      from_email: email,
      subject: "New quote request from CostaMate — " + company.name,
      message: "From: " + name + " (" + email + ")\nPhone: " + (phone||"Not given") + "\n\n" + msg,
      from_name: name,
    });
    setTimeout(() => { setSending(false); setSent(true); onSent && onSent(); }, 800);
  };

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-head">
          <h3>Request a quote</h3>
          <button className="modal-close" onClick={onClose}><X size={18} strokeWidth={2} /></button>
        </div>
        {sent ? (
          <div className="sent-state">
            <CheckCircle size={36} strokeWidth={1.5} color="#2D9B6F" />
            <p>Sent! {company.name} will be in touch.</p>
            <Btn onClick={onClose}>Done</Btn>
          </div>
        ) : (
          <div className="modal-body">
            <Field label="Your name"><input className="input" value={name} onChange={e=>setName(e.target.value)} /></Field>
            <Field label="Your email"><input className="input" type="email" value={email} onChange={e=>setEmail(e.target.value)} /></Field>
            <Field label="Phone" sub="optional"><PhoneInput value={phone} onChange={setPhone} /></Field>
            <Field label="What do you need?">
              <textarea className="input textarea" rows={4} value={msg} onChange={e=>setMsg(e.target.value)}
                placeholder={"Describe what you need and " + company.name + " will get back to you..."} />
            </Field>
            <Btn full onClick={send} disabled={sending||!name||!email||!msg}>
              {sending ? "Sending..." : "Send request"}
            </Btn>
          </div>
        )}
      </div>
    </div>
  );
}

// ---
function SignupForm({ onSubmit, onCancel, companies }) {
  const [form, setForm] = useState({name:"",email:"",phone:"",category:"home_garden",
    baseTown:"Marbella",coverageRadius:20,blurb:"",services:"",priceFrom:"",emergency:false,whatsapp:""});
  const [step, setStep] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const u = (k,v) => setForm(f => ({...f,[k]:v}));
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [veriffUrl, setVeriffUrl] = useState(null);
  const [veriffSessionId, setVeriffSessionId] = useState(null);

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPhotoFile(file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  const submit = async () => {
    setSubmitting(true);
    let photoUrl = null;
    if (photoFile) {
      setUploading(true);
      photoUrl = await uploadPhoto(photoFile);
      setUploading(false);
    }
    const company = {
      ...form,
      id: Date.now()+"",
      status: "pending",
      verified: false,
      services: form.services.split(",").map(s=>s.trim()).filter(Boolean),
      towns: [form.baseTown],
      photos: photoUrl ? [photoUrl] : [],
      submittedAt: new Date().toISOString(),
    };
    sendEmail({
      to_email: form.email,
      from_email: "Admin@costamate.com",
      subject: "✅ We've received your CostaMate listing — " + form.name,
      message: "Hi " + (form.name || "there") + ",\n\n" +
        "Thank you for submitting your listing to CostaMate! We're excited to have you on board.\n\n" +
        "Here's what happens next:\n\n" +
        "1. Complete your identity verification — if you haven't already, please complete the quick Veriff check to get your Verified badge.\n\n" +
        "2. We'll review your listing within 48 hours — we check every listing before it goes live to maintain quality for our residents.\n\n" +
        "3. You'll receive a confirmation email — once approved, you'll be live on costamate.com and visible to English-speaking residents across the Costa del Sol.\n\n" +
        "4. Log into your company dashboard anytime at costamate.com to view and update your listing.\n\n" +
        "💡 Tip: All new companies get 30 days Featured free — top of search results and included in our emergency alert system. You can activate this from your dashboard once approved.\n\n" +
        "If you have any questions, just reply to this email and we'll get back to you.\n\n" +
        "Welcome to CostaMate!\n\n" +
        "Ella Stowell\nFounder, CostaMate\nAdmin@costamate.com\ncostamate.com",
      from_name: "CostaMate",
    });
    sendEmail({
      to_email: ADMIN_EMAIL,
      subject: "🔔 New listing pending approval: " + form.name,
      message: "A new company has submitted a listing and is awaiting your approval.\n\n" +
        "Company: " + form.name + "\n" +
        "Email: " + form.email + "\n" +
        "Phone: " + form.phone + "\n" +
        "Mobile (SMS): " + form.whatsapp + "\n" +
        "Category: " + form.category + "\n" +
        "Base: " + form.baseTown + " · Covers up to " + form.coverageRadius + "km\n" +
        "Description: " + form.blurb + "\n" +
        (localStorage.getItem("cm:ref") ? "Referred by company ID: " + localStorage.getItem("cm:ref") + "\n" : "") +
        "\nLog in to approve: https://costamate.com",
    });
    // Credit referrer if applicable
    const refId = localStorage.getItem("cm:ref");
    if (refId) {
      const refCompany = companies.find(c => c.id === refId);
      if (refCompany) {
        const newCount = (refCompany.referralCount || 0) + 1;
        fbUpdateCompany(refId, {referralCount: newCount});
        if (newCount % 3 === 0) {
          sendEmail({
            to_email: refCompany.email,
            subject: "🎁 You've earned a free month of Featured — CostaMate",
            message: "Congratulations! You've referred " + newCount + " companies to CostaMate.\n\nAs a thank you, we're giving you 1 free month of Featured (worth €25). We'll apply it to your account within 24 hours.\n\nKeep referring to earn more!\n\nElla\nAdmin@costamate.com",
            from_name: "CostaMate"
          });
          sendEmail({
            to_email: ADMIN_EMAIL,
            subject: "🎁 Referral reward due: " + refCompany.name,
            message: refCompany.name + " has referred " + newCount + " companies and is due 1 free month of Featured.\n\nApply manually in admin panel.",
            from_name: "CostaMate"
          });
        }
        localStorage.removeItem("cm:ref");
      }
    }
    // Start Veriff session
    try {
      const res = await apiCall("createVeriffSession", { name: form.name, companyId: company.id });
      if (res?.verification?.url) {
        setVeriffUrl(res.verification.url);
        setVeriffSessionId(res.verification.id);
      }
    } catch(e) { console.error("Veriff error:", e); }
    setTimeout(() => { setSubmitting(false); onSubmit(company); }, 1000);
  };

  if (step === 0) return (
    <div className="form-steps">
      <h2 className="form-title">List your company</h2>
      <p className="form-sub">Free to list. We'll review and approve within 48 hours.</p>
      <Field label="Company name"><input className="input" value={form.name} onChange={e=>u("name",e.target.value)} /></Field>
      <Field label="Email"><input className="input" type="email" value={form.email} onChange={e=>u("email",e.target.value)} /></Field>
      <Field label="Phone" sub="shown on your listing"><PhoneInput value={form.phone} onChange={v=>u("phone",v)} /></Field>
      <Field label="Mobile for SMS alerts" sub="receives emergency job alerts — must be a mobile number"><PhoneInput value={form.whatsapp} onChange={v=>u("whatsapp",v)} /></Field>
      <Field label="Category">
        <select className="input" value={form.category} onChange={e=>u("category",e.target.value)}>
          {CATEGORIES.map(c=><option key={c.id} value={c.id}>{c.label}</option>)}
        </select>
      </Field>
      <Field label="Where are you based?">
        <select className="input" value={form.baseTown} onChange={e=>u("baseTown",e.target.value)}>
          {TOWNS.map(t=><option key={t}>{t}</option>)}
        </select>
      </Field>
      <Field label="How far do you travel?" sub="from your base location">
        <div className="radius-options">
          {[5,10,20,50,150].map((r,i) => (
            <button type="button" key={r}
              className={"radius-btn"+(form.coverageRadius===r?" radius-btn-on":"")}
              onClick={()=>u("coverageRadius",r)}>
              <span className="radius-km">{["5km","10km","20km","50km","Whole coast"][i]}</span>
              <span className="radius-desc">
                {["Very local","Nearby","Town & surrounds","Wide area","Full Costa del Sol"][i]}
              </span>
            </button>
          ))}
        </div>
      </Field>
      <Btn full onClick={() => setStep(1)} disabled={!form.name||!form.email||!form.phone}>Next</Btn>
    </div>
  );

  return (
    <div className="form-steps">
      <button className="form-back" onClick={() => setStep(0)}><ArrowLeft size={14} strokeWidth={2} /> Back</button>
      <h2 className="form-title">About your company</h2>
      <Field label="Short description" sub="shown in search results">
        <textarea className="input textarea" rows={3} value={form.blurb}
          onChange={e=>u("blurb",e.target.value)} placeholder="We provide..." />
      </Field>
      <Field label="Services" sub="comma separated">
        <input className="input" value={form.services} onChange={e=>u("services",e.target.value)} placeholder="Cleaning, ironing, windows..." />
      </Field>
      <Field label="Company photo" sub="optional — logo or photo of your work">
        <label className="photo-upload-label">
          {photoPreview
            ? <img src={photoPreview} alt="preview" className="photo-preview" />
            : <div className="photo-upload-placeholder">
                <Upload size={24} strokeWidth={1.5} color="#9A9486" />
                <span>Tap to add a photo</span>
              </div>}
          <input type="file" accept="image/*" onChange={handlePhoto}
            style={{display:"none"}} />
        </label>
      </Field>
      <Field label="Starting price" sub="optional">
        <input className="input" value={form.priceFrom} onChange={e=>u("priceFrom",e.target.value)} placeholder="e.g. From €50" />
      </Field>
      <Field label="Typical response time" sub="helps residents know what to expect">
        <select className="input" value={form.responseTime||""} onChange={e=>u("responseTime",e.target.value)}>
          <option value="">Select...</option>
          <option value="Within 1 hour">Within 1 hour</option>
          <option value="Within 2 hours">Within 2 hours</option>
          <option value="Within 4 hours">Within 4 hours</option>
          <option value="Same day">Same day</option>
          <option value="Within 24 hours">Within 24 hours</option>
          <option value="Within 48 hours">Within 48 hours</option>
        </select>
      </Field>
      <label className="check-label">
        <input type="checkbox" checked={form.emergency} onChange={e=>u("emergency",e.target.checked)} />
        Available for 24hr emergency callouts
      </label>
      <label className="check-label" style={{alignItems:"flex-start",gap:10,marginTop:4}}>
        <input type="checkbox" id="tc-accept" style={{marginTop:3,flexShrink:0}}
          onChange={e => e.target.closest("form") || null} />
        <span style={{fontSize:12,color:"#6B6659",lineHeight:1.5}}>
          I agree to the CostaMate <a href="https://costamate.com" target="_blank" rel="noopener noreferrer" style={{color:"#C75D3A",fontWeight:700,fontSize:12}}>Terms & Conditions</a>. Standard listings are completely free — no card required, no hidden charges. Optional Featured upgrade is €25/month after a 30-day free trial, cancel any time.
        </span>
      </label>
      <Btn full onClick={submit} disabled={submitting||uploading||!form.blurb}>
        {uploading ? "Uploading photo..." : submitting ? "Submitting..." : "Submit listing"}
      </Btn>
    </div>
  );

  // Veriff verification screen - shows after submission
  if (veriffUrl) return (
    <div className="form-steps">
      <div className="veriff-screen">
        <ShieldCheck size={48} strokeWidth={1.5} color="#1B3A4B" />
        <h2 className="form-title">One last step</h2>
        <p className="form-sub">To protect residents, all companies on CostaMate must verify their identity. This takes 2-3 minutes.</p>
        <div className="veriff-badge">🔒 Powered by Veriff — bank-level identity verification</div>
        <Btn full onClick={() => window.open(veriffUrl, "_blank")}>Start verification →</Btn>
        <p style={{fontSize:12,color:"#9A9486",textAlign:"center",marginTop:8}}>Your listing is submitted and under review. Verification adds a trust badge to your profile.</p>
      </div>
    </div>
  );
}

function CompanyDashboard({ company, onBack, onUpdate, allCompanies }) {
  const [tab, setTab] = useState("listing");
  const [editing, setEditing] = useState(null);
  const [editData, setEditData] = useState({...company});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [enquiries, setEnquiries] = useLocal("cm:enquiries:" + company.id, []);
  const [jobs, setJobs] = useLocal("cm:jobs:" + company.id, []);
  const [recommendations, setRecommendations] = useLocal("cm:recs:" + company.id, []);
  const [recSearch, setRecSearch] = useState("");
  const otherCompanies = (allCompanies||[]).filter(c => 
    c.id !== company.id && c.status === "approved" &&
    (recSearch === "" || c.name.toLowerCase().includes(recSearch.toLowerCase()) || 
    (c.category && c.category.toLowerCase().includes(recSearch.toLowerCase())))
  );

  const saveEdit = async () => {
    setSaving(true);
    await onUpdate(editData);
    setSaving(false);
    setSaved(true);
    setEditing(false);
    setTimeout(() => setSaved(false), 2000);
  };

  const markComplete = (jobId) => {
    setJobs(prev => prev.map(j => j.id === jobId ? {...j, status:"complete", completedAt: new Date().toISOString()} : j));
  };

  const referralLink = "https://costamate.com?ref=" + company.id;
  const referralCount = company.referralCount || 0;
  const referralsNeeded = 3;
  const referralsLeft = Math.max(0, referralsNeeded - (referralCount % referralsNeeded));

  const tabs = [["listing","My Listing"],["enquiries","Enquiries"],["jobs","Jobs"],["recommend","Recommend & Earn"]];

  return (
    <div className="screen">
      <Topbar onBack={onBack} title="" light />
      <div className="cd-header">
        {company.photos?.[0]
          ? <img src={company.photos[0]} alt="" className="cd-cover" />
          : <div className="cd-cover-placeholder"><Building2 size={32} strokeWidth={1.5} color="#fff" /></div>}
        <div className="cd-header-info">
          <h2 className="cd-company-name">{company.name}</h2>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:4}}>
            <span className={"status-badge status-"+company.status}>{company.status}</span>
            {company.featured && <span className="cc-badge cc-badge-sp" style={{position:"static",fontSize:11}}>⭐ Featured</span>}
            {company.verified && <span style={{fontSize:11,fontWeight:700,color:"#2D9B6F",background:"rgba(240,253,244,0.9)",borderRadius:20,padding:"2px 8px"}}>✓ Vetted</span>}
          </div>
        </div>
      </div>
      <div className="admin-stats-row">
        <div className="admin-stat"><span className="admin-stat-num">{enquiries.length}</span><span className="admin-stat-label">Enquiries</span></div>
        <div className="admin-stat"><span className="admin-stat-num">{jobs.filter(j=>j.status!=="complete").length}</span><span className="admin-stat-label">Active Jobs</span></div>
        <div className="admin-stat"><span className="admin-stat-num">{jobs.filter(j=>j.status==="complete").length}</span><span className="admin-stat-label">Completed</span></div>
        <div className="admin-stat"><span className="admin-stat-num">{referralCount}</span><span className="admin-stat-label">Referrals</span></div>
      </div>
      <div className="admin-tabs">
        {tabs.map(([id,label]) => (
          <button key={id} className={"admin-tab"+(tab===id?" admin-tab-on":"")} onClick={()=>setTab(id)}>
            {label}{id==="enquiries"&&enquiries.filter(e=>!e.read).length>0?<span className="tab-count">{enquiries.filter(e=>!e.read).length}</span>:""}
          </button>
        ))}
      </div>
      <div className="portal-body">
        {tab === "listing" && (
          <div>
            {saved && <div className="success-banner"><CheckCircle size={16} strokeWidth={2} /> Changes saved!</div>}
            <div className="admin-card" style={{marginBottom:12}}>
              {company.photos?.[0] && <img src={company.photos[0]} alt="" style={{width:"100%",borderRadius:8,marginBottom:12,maxHeight:200,objectFit:"cover"}} />}
              
              {[
                {label:"Company name", key:"name", type:"text"},
                {label:"Phone", key:"phone", type:"tel"},
                {label:"Mobile (SMS)", key:"whatsapp", type:"tel"},
                {label:"Website", key:"website", type:"url"},
                {label:"Starting price", key:"priceFrom", type:"text"},
              ].map(({label,key,type}) => (
                <div key={key} className="company-detail-row" style={{alignItems:"center"}}>
                  <span className="detail-label">{label}</span>
                  {editing === key ? (
                    <div style={{display:"flex",gap:6,flex:1,justifyContent:"flex-end"}}>
                      <input className="input" type={type} style={{maxWidth:180,fontSize:13}}
                        value={editData[key]||""}
                        onChange={e=>setEditData(p=>({...p,[key]:e.target.value}))} />
                      <button className="job-complete-btn" onClick={async()=>{
                        setSaving(true);
                        await onUpdate({...company,...editData});
                        setSaving(false); setSaved(true); setEditing(null);
                        setTimeout(()=>setSaved(false),2000);
                      }}>{saving?"...":"Save"}</button>
                      <button style={{background:"none",border:"none",color:"#9A9486",cursor:"pointer",fontSize:12}}
                        onClick={()=>{setEditing(null);setEditData({...company});}}>Cancel</button>
                    </div>
                  ) : (
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      <span style={{fontSize:13,color:"#4B5563"}}>{company[key]||"—"}</span>
                      <button style={{background:"none",border:"none",color:"#C75D3A",cursor:"pointer",fontSize:12,fontWeight:700}}
                        onClick={()=>setEditing(key)}>Edit</button>
                    </div>
                  )}
                </div>
              ))}

              <div className="company-detail-row">
                <span className="detail-label">Description</span>
                {editing === "blurb" ? (
                  <div style={{display:"flex",flexDirection:"column",gap:6,flex:1}}>
                    <textarea className="input textarea" rows={3} style={{fontSize:13}}
                      value={editData.blurb||""}
                      onChange={e=>setEditData(p=>({...p,blurb:e.target.value}))} />
                    <div style={{display:"flex",gap:6}}>
                      <button className="job-complete-btn" onClick={async()=>{
                        setSaving(true);
                        await onUpdate({...company,...editData});
                        setSaving(false); setSaved(true); setEditing(null);
                        setTimeout(()=>setSaved(false),2000);
                      }}>{saving?"...":"Save"}</button>
                      <button style={{background:"none",border:"none",color:"#9A9486",cursor:"pointer",fontSize:12}}
                        onClick={()=>{setEditing(null);setEditData({...company});}}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div style={{display:"flex",gap:8,alignItems:"flex-start",flex:1,justifyContent:"flex-end"}}>
                    <span style={{fontSize:13,color:"#4B5563",maxWidth:200,textAlign:"right"}}>{company.blurb||"—"}</span>
                    <button style={{background:"none",border:"none",color:"#C75D3A",cursor:"pointer",fontSize:12,fontWeight:700,flexShrink:0}}
                      onClick={()=>setEditing("blurb")}>Edit</button>
                  </div>
                )}
              </div>

              <div className="company-detail-row">
                <span className="detail-label">Category</span>
                <span style={{fontSize:13,color:"#4B5563"}}>{CATEGORIES.find(c=>c.id===company.category)?.label}</span>
              </div>
              <div className="company-detail-row">
                <span className="detail-label">Base town</span>
                <span style={{fontSize:13,color:"#4B5563"}}>{company.baseTown||company.town}</span>
              </div>
              <div className="company-detail-row">
                <span className="detail-label">Coverage radius</span>
                <span style={{fontSize:13,color:"#4B5563"}}>{company.coverageRadius}km</span>
              </div>
              <div className="company-detail-row">
                <span className="detail-label">Emergency callouts</span>
                <span style={{fontSize:13,color:"#4B5563"}}>{company.emergency?"✓ Yes":"No"}</span>
              </div>
            </div>
          </div>
        )}
        {tab === "enquiries" && (
          <div>
            {enquiries.length === 0 ? (
              <div className="portal-empty">
                <MessageSquare size={36} strokeWidth={1.5} color="#1B3A4B" />
                <h3>No enquiries yet</h3>
                <p>When residents contact you through CostaMate, their messages will appear here.</p>
              </div>
            ) : enquiries.map(e => (
              <div key={e.id} className="job-card" onClick={()=>setEnquiries(prev=>prev.map(x=>x.id===e.id?{...x,read:true}:x))}>
                <div className="job-card-head">
                  <strong>{e.fromName}</strong>
                  <span className="job-date">{new Date(e.date).toLocaleDateString()}</span>
                </div>
                <p className="job-msg">{e.message}</p>
                {e.fromEmail && <a href={"mailto:"+e.fromEmail} className="job-reply">Reply by email →</a>}
              </div>
            ))}
          </div>
        )}
        {tab === "jobs" && (
          <div>
            {jobs.length === 0 ? (
              <div className="portal-empty">
                <Briefcase size={36} strokeWidth={1.5} color="#1B3A4B" />
                <h3>No jobs yet</h3>
                <p>Jobs you accept from enquiries will appear here so you can track them.</p>
              </div>
            ) : jobs.map(j => (
              <div key={j.id} className={"job-card"+(j.status==="complete"?" job-complete":"")}>
                <div className="job-card-head">
                  <strong>{j.title||"Job"}</strong>
                  <span className={"job-status-badge job-"+j.status}>{j.status}</span>
                </div>
                <p className="job-msg">{j.description}</p>
                <div className="job-card-foot">
                  <span className="job-date">{new Date(j.createdAt).toLocaleDateString()}</span>
                  {j.status !== "complete" && (
                    <button className="job-complete-btn" onClick={()=>markComplete(j.id)}>Mark complete</button>
                  )}
                  {j.status === "complete" && <span className="job-done">✓ Completed {new Date(j.completedAt).toLocaleDateString()}</span>}
                </div>
              </div>
            ))}
          </div>
        )}
        {tab === "recommend" && (
          <div>
            <div className="referral-banner">
              <div className="referral-banner-top">
                <span className="referral-emoji">🎁</span>
                <div>
                  <strong>Earn a free month of Featured</strong>
                  <p>Refer 3 companies to CostaMate and get 1 month Featured free (worth €25).</p>
                </div>
              </div>
              <div className="referral-progress">
                <div className="referral-progress-bar">
                  <div className="referral-progress-fill" style={{width: Math.min(100, (referralCount % referralsNeeded) / referralsNeeded * 100) + "%"}} />
                </div>
                <span className="referral-progress-text">
                  {referralCount % referralsNeeded === 0 && referralCount > 0
                    ? "🎉 You've earned a free month! We'll apply it shortly."
                    : referralsLeft + " more referral" + (referralsLeft === 1 ? "" : "s") + " to earn your free month"}
                </span>
              </div>
              <div className="referral-total">{referralCount} total referral{referralCount !== 1 ? "s" : ""} · {Math.floor(referralCount / referralsNeeded)} free month{Math.floor(referralCount/referralsNeeded)!==1?"s":""} earned</div>
            </div>

            <div className="referral-link-box">
              <p style={{fontSize:13,fontWeight:700,color:"#1B3A4B",marginBottom:6}}>Your referral link</p>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <input className="input" value={referralLink} readOnly style={{fontSize:12,flex:1}} />
                <button className="job-complete-btn" onClick={() => {
                  navigator.clipboard.writeText(referralLink);
                  alert("Copied!");
                }}>Copy</button>
              </div>
              <a className="btn btn-wa btn-full" style={{marginTop:8,textAlign:"center",display:"block",fontSize:13}}
                href={"https://wa.me/?text="+encodeURIComponent("Hi! I use CostaMate to connect with English-speaking residents on the Costa del Sol. List your company free here: " + referralLink)}
                target="_blank" rel="noopener noreferrer">
                📤 Share via WhatsApp
              </a>
            </div>

            <div style={{marginTop:20}}>
              <p style={{fontSize:13,color:"#6B6659",marginBottom:12,lineHeight:1.5}}>
                Also recommend other CostaMate companies to your clients — they'll appear on your listing page.
              </p>
              {recommendations.length > 0 && (
                <div style={{marginBottom:16}}>
                  <h4 style={{fontSize:13,fontWeight:700,color:"#1B3A4B",marginBottom:8}}>Your recommendations ({recommendations.length})</h4>
                  {recommendations.map(r => (
                    <div key={r.id} className="job-card" style={{flexDirection:"column",gap:8}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <div style={{flex:1}}>
                          <strong style={{fontSize:14}}>{r.name}</strong>
                          <p className="job-msg">{CATEGORIES.find(c=>c.id===r.category)?.label}</p>
                        </div>
                        <button onClick={()=>setRecommendations(prev=>prev.filter(x=>x.id!==r.id))}
                          style={{background:"none",border:"none",color:"#C75D3A",cursor:"pointer",fontSize:18}}>×</button>
                      </div>
                      <a className="btn btn-wa btn-full"
                        style={{textAlign:"center",fontSize:12,padding:"6px 12px"}}
                        href={"https://wa.me/?text="+encodeURIComponent(
                          "Hi! I recommend " + r.name + " — they're listed on CostaMate, a trusted directory for English-speaking residents on the Costa del Sol.\n\nView their profile and send a quote request here: https://costamate.com\n\nIf your company isn't listed yet, you can join free: " + referralLink
                        )}
                        target="_blank" rel="noopener noreferrer">
                        📤 Share {r.name} + your referral link
                      </a>
                    </div>
                  ))}
                </div>
              )}
              <h4 style={{fontSize:13,fontWeight:700,color:"#1B3A4B",marginBottom:8}}>Add a recommendation</h4>
              <input className="input" value={recSearch} onChange={e=>setRecSearch(e.target.value)}
                placeholder="Search companies..." style={{marginBottom:8}} />
              {recSearch && otherCompanies.slice(0,10).map(c => {
                const already = recommendations.some(r=>r.id===c.id);
                return (
                  <div key={c.id} className="job-card" style={{flexDirection:"row",alignItems:"center"}}>
                    <div style={{flex:1}}>
                      <strong style={{fontSize:14}}>{c.name}</strong>
                      <p className="job-msg">{CATEGORIES.find(cat=>cat.id===c.category)?.label} · {c.baseTown||c.town}</p>
                    </div>
                    <button className="job-complete-btn"
                      style={{background:already?"#9A9486":"#1B3A4B"}}
                      onClick={()=>{
                        if (already) return;
                        setRecommendations(prev=>[...prev,{id:c.id,name:c.name,category:c.category}]);
                        setRecSearch("");
                      }}>
                      {already ? "Added" : "+ Add"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function PortalView({ companies, onSubmit, onBack, user, onUpdate, allCompanies }) {
  const [view, setView] = useState("home");
  const [submitted, setSubmitted] = useState(false);
  const [myCompanyId, setMyCompanyId] = useLocal("cm:mycompany", null);
  const [trialTcAccepted, setTrialTcAccepted] = useState(false);
  const mine = (companies||[]).filter(c =>
    c.email === user?.email || c.id === myCompanyId
  );
  const latest = mine[mine.length-1];

  // If company exists and is approved, show full dashboard
  if (latest && latest.status === "approved") return (
    <CompanyDashboard company={latest} onBack={onBack} onUpdate={onUpdate} allCompanies={allCompanies} />
  );

  // If we just submitted, show pending state even before Airtable loads
  const showPending = submitted || latest;

  if (view === "list") return (
    <div className="screen">
      <Topbar onBack={() => setView("home")} title="List your company" light />
      <div className="portal-body">
        <SignupForm
          companies={companies}
          onSubmit={c => { onSubmit(c); setMyCompanyId(c.id); setSubmitted(true); setView("home"); }}
          onCancel={() => setView("home")}
        />
      </div>
    </div>
  );

  return (
    <div className="screen">
      <Topbar onBack={onBack} title="Company Portal" light />
      <div className="portal-body">
        {submitted && (
          <div className="success-banner">
            <CheckCircle size={16} strokeWidth={2} /> Listing submitted — we'll review within 48 hours.
          </div>
        )}
        {latest ? (
          <div className="portal-listing">
            <div className="portal-listing-head">
              <h3>{latest.name}</h3>
              <span className={"status-badge status-"+latest.status}>{latest.status}</span>
            </div>
            <p className="portal-listing-cat">{CATEGORIES.find(c=>c.id===latest.category)?.label} · {latest.baseTown || latest.town}</p>
            {latest.status === "pending" && <p className="portal-note">Your listing is under review. We'll email you when it's approved.</p>}
            {latest.status === "approved" && <p className="portal-note" style={{color:"#065F46",background:"#D1FAE5"}}>Your listing is live! Residents can now find and contact you.</p>}
            {latest.status === "rejected" && <p className="portal-note err">{latest.rejectReason || "Your listing was not approved. Please contact Admin@costamate.com."}</p>}
            <div className="portal-pricing">
              <h4>Plans</h4>
              <div className="pricing-cards">
                <div className="pricing-card">
                  <span className="pricing-name">Standard</span>
                  <span className="pricing-price">Free</span>
                  <ul className="pricing-features">
                    <li><Check size={12} strokeWidth={2.5} /> Listed in searches</li>
                    <li><Check size={12} strokeWidth={2.5} /> Receive quote requests</li>
                    <li><Check size={12} strokeWidth={2.5} /> Collect reviews</li>
                  </ul>
                </div>
                <div className="pricing-card pricing-card-featured">
                  <span className="pricing-badge">Recommended</span>
                  <span className="pricing-name">Featured</span>
                  <span className="pricing-price">€25<small>/mo</small></span>
                  <div style={{fontSize:11,fontWeight:700,color:"#92400E",background:"#FEF3C7",borderRadius:6,padding:"4px 8px",marginBottom:8}}>🎁 30 days free</div>
                  <ul className="pricing-features">
                    <li><Check size={12} strokeWidth={2.5} /> Top of results</li>
                    <li><Check size={12} strokeWidth={2.5} /> Featured badge</li>
                    <li><Check size={12} strokeWidth={2.5} /> Emergency alerts</li>
                  </ul>
                  <label style={{display:"flex",gap:8,alignItems:"flex-start",fontSize:11,color:"#6B6659",margin:"8px 0",cursor:"pointer",textAlign:"left"}}>
                    <input type="checkbox" checked={trialTcAccepted} onChange={e=>setTrialTcAccepted(e.target.checked)} style={{marginTop:2,flexShrink:0}} />
                    <span>I agree that my first payment of €25 will be taken after 30 days. I can cancel any time before then at no cost. I accept the <a href="https://costamate.com" target="_blank" rel="noopener noreferrer" style={{color:"#C75D3A",fontWeight:700}}>Terms & Conditions</a>.</span>
                  </label>
                  <Btn href={trialTcAccepted ? STRIPE_URL : undefined} variant="primary" full
                    onClick={!trialTcAccepted ? () => alert("Please accept the terms to continue.") : undefined}
                    style={{opacity: trialTcAccepted ? 1 : 0.5}}>
                    Start free trial
                  </Btn>
                </div>
              </div>
            </div>
          </div>
        ) : submitted ? (
          <div className="portal-listing">
            <div className="portal-listing-head">
              <h3>Listing submitted</h3>
              <span className="status-badge status-pending">pending</span>
            </div>
            <p className="portal-note">Your listing is under review. We'll email you within 48 hours.</p>
          </div>
        ) : (
          <div className="portal-empty">
            <div className="portal-empty-icon">
              <Building2 size={36} strokeWidth={1.5} color="#1B3A4B" />
            </div>
            <h3>List your company</h3>
            <p>Join CostaMate free and start receiving enquiries from English-speaking residents on the Costa del Sol.</p>
            <div className="portal-empty-features">
              <div className="portal-empty-feature">✓ Completely free to list</div>
              <div className="portal-empty-feature">✓ No card required</div>
              <div className="portal-empty-feature">✓ No hidden charges</div>
              <div className="portal-empty-feature">✓ Quote requests direct to your email</div>
              <div className="portal-empty-feature">✓ Approved within 48 hours</div>
            </div>
            <button className="portal-cta-btn" onClick={() => setView("list")}>
              Get started — it's free
            </button>
            <p className="portal-empty-sub">No card required. No contract. Cancel any time.</p>
          </div>
        )}
      </div>
    </div>
  );
}

// ---
function AdminView({ companies, onApprove, onReject, onRemove, onBack, showPreview, onTogglePreview, onToggleFeatured, onToggleVerified }) {
  const [tab, setTab] = useState("pending");
  const [members, setMembers] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [activityLog, setActivityLog] = useLocal("cm:activity", []);
  const [noteText, setNoteText] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyNote, setCompanyNote] = useState("");
  const [companyNotes, setCompanyNotes] = useLocal("cm:cnotes", {});
  const pending = (companies||[]).filter(c=>c.status==="pending");
  const approved = (companies||[]).filter(c=>c.status==="approved");
  const rejected = (companies||[]).filter(c=>c.status==="rejected");
  const list = tab==="pending"?pending:tab==="approved"?approved:rejected;

  React.useEffect(() => {
    if (tab === "members" && members.length === 0) {
      setLoadingMembers(true);
      apiCall("getMembers", {}).then(data => {
        setMembers(Array.isArray(data) ? data : []);
        setLoadingMembers(false);
      }).catch(() => setLoadingMembers(false));
    }
  }, [tab]);

  const addActivity = (type, text) => {
    setActivityLog(prev => [{type, text, date: new Date().toISOString()}, ...prev].slice(0, 100));
  };

  const approve = (c) => {
    sendEmail({to_email:c.email, subject:"Your CostaMate listing is live — "+c.name,
      message:"Great news! Your listing has been approved and is now live on CostaMate.\n\nThe CostaMate team",
      from_name:"CostaMate"});
    onApprove(c.id);
    addActivity("approve", "✅ Approved: " + c.name + " (" + c.email + ")");
  };

  const reject = (c) => {
    sendEmail({to_email:c.email, subject:"Update needed — "+c.name,
      message:"Thank you for applying. We cannot approve your listing at this time.\nEmail Admin@costamate.com with questions.\n\nThe CostaMate team",
      from_name:"CostaMate"});
    onReject(c.id);
    addActivity("reject", "❌ Rejected: " + c.name + " (" + c.email + ")");
  };

  return (
    <div className="screen">
      <Topbar onBack={selectedCompany ? () => setSelectedCompany(null) : onBack} title={selectedCompany ? selectedCompany.name : "Admin"} light />

      {selectedCompany ? (
        <div className="admin-list" style={{paddingTop:16}}>
          {/* Status badges */}
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
            <span className={"status-badge status-"+selectedCompany.status}>{selectedCompany.status}</span>
            {selectedCompany.featured && <span className="cc-badge cc-badge-sp" style={{position:"static",fontSize:11}}>⭐ Featured</span>}
            {selectedCompany.verified && <span style={{fontSize:11,fontWeight:700,color:"#2D9B6F",background:"#F0FDF4",borderRadius:20,padding:"2px 8px"}}>✓ Verified</span>}
            {selectedCompany.paid_verification && <span style={{fontSize:11,fontWeight:700,color:"#1B3A4B",background:"#F0EAD8",borderRadius:20,padding:"2px 8px"}}>£ Fee paid</span>}
          </div>

          {/* Company details */}
          <div className="admin-card">
            {selectedCompany.photos?.[0] && <img src={selectedCompany.photos[0]} alt="" style={{width:"100%",borderRadius:8,marginBottom:8,maxHeight:160,objectFit:"cover"}} />}
            <div className="company-detail-row"><span className="detail-label">Email</span><span>{selectedCompany.email}</span></div>
            <div className="company-detail-row"><span className="detail-label">Phone</span><span>{selectedCompany.phone||"—"}</span></div>
            <div className="company-detail-row"><span className="detail-label">Mobile</span><span>{selectedCompany.whatsapp||"—"}</span></div>
            <div className="company-detail-row"><span className="detail-label">Category</span><span>{CATEGORIES.find(c=>c.id===selectedCompany.category)?.label}</span></div>
            <div className="company-detail-row"><span className="detail-label">Base</span><span>{selectedCompany.baseTown||selectedCompany.town}</span></div>
            <div className="company-detail-row"><span className="detail-label">Radius</span><span>{selectedCompany.coverageRadius}km</span></div>
            <div className="company-detail-row"><span className="detail-label">Website</span><span>{selectedCompany.website||"—"}</span></div>
            <div className="company-detail-row"><span className="detail-label">Emergency</span><span>{selectedCompany.emergency?"Yes":"No"}</span></div>
            <div className="company-detail-row"><span className="detail-label">Referrals</span><span>{selectedCompany.referralCount||0}</span></div>
            <div className="company-detail-row"><span className="detail-label">Submitted</span><span>{selectedCompany.submittedAt ? new Date(selectedCompany.submittedAt).toLocaleDateString("en-GB") : "—"}</span></div>
            {selectedCompany.blurb && <p style={{fontSize:13,color:"#4B5563",marginTop:8,lineHeight:1.5}}>{selectedCompany.blurb}</p>}
          </div>

          {/* Actions */}
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16}}>
            {selectedCompany.status==="pending" && <>
              <Btn onClick={() => { approve(selectedCompany); setSelectedCompany(null); }}>Approve</Btn>
              <Btn variant="secondary" onClick={() => { reject(selectedCompany); setSelectedCompany(null); }}>Reject</Btn>
            </>}
            {selectedCompany.status==="approved" && <>
              <Btn variant="secondary" onClick={() => { onToggleFeatured(selectedCompany); setSelectedCompany({...selectedCompany, featured:!selectedCompany.featured}); }}>
                {selectedCompany.featured ? "Remove Featured" : "⭐ Make Featured"}
              </Btn>
              <Btn variant="secondary" onClick={() => { onToggleVerified(selectedCompany); setSelectedCompany({...selectedCompany, verified:!selectedCompany.verified}); }}>
                {selectedCompany.verified ? "Remove Verified" : "✓ Mark Verified"}
              </Btn>
            </>}
            <Btn variant="secondary" onClick={() => { onRemove(selectedCompany.id); setSelectedCompany(null); }}>Remove</Btn>
          </div>

          {/* Notes */}
          <div className="admin-card">
            <h4 style={{fontSize:14,fontWeight:700,color:"#1B3A4B",marginBottom:10}}>📝 Notes</h4>
            {(companyNotes[selectedCompany.id]||[]).map((n,i) => (
              <div key={i} className="activity-item">
                <span className="activity-text">{n.text}</span>
                <span className="activity-date">{new Date(n.date).toLocaleDateString("en-GB")}</span>
              </div>
            ))}
            <div style={{display:"flex",gap:8,marginTop:8}}>
              <input className="input" value={companyNote} onChange={e=>setCompanyNote(e.target.value)}
                placeholder="Add a note about this company..." style={{flex:1}} />
              <Btn onClick={() => {
                if (!companyNote.trim()) return;
                const note = {text: companyNote.trim(), date: new Date().toISOString()};
                setCompanyNotes(prev => ({...prev, [selectedCompany.id]: [...(prev[selectedCompany.id]||[]), note]}));
                addActivity("note", "📝 Note on " + selectedCompany.name + ": " + companyNote.trim());
                setCompanyNote("");
              }}>Save</Btn>
            </div>
          </div>
        </div>
      ) : (
      <>
      <div className="admin-stats-row">
        <div className="admin-stat"><span className="admin-stat-num">{approved.length}</span><span className="admin-stat-label">Live</span></div>
        <div className="admin-stat"><span className="admin-stat-num">{pending.length}</span><span className="admin-stat-label">Pending</span></div>
        <div className="admin-stat"><span className="admin-stat-num">{(companies||[]).filter(c=>c.featured).length}</span><span className="admin-stat-label">Featured</span></div>
        <div className="admin-stat"><span className="admin-stat-num">{(companies||[]).filter(c=>c.paid_verification&&c.verified).length}</span><span className="admin-stat-label">Vetted</span></div>
      </div>
      <div className="admin-preview-toggle">
        <span>Show demo listing (Costa Clean Pro)</span>
        <button className={"toggle-btn" + (showPreview ? " toggle-on" : "")}
          onClick={onTogglePreview}>
          {showPreview ? "On" : "Off"}
        </button>
      </div>
      <div className="admin-tabs">
        {[["pending","Pending",pending.length],["approved","Live",approved.length],["rejected","Rejected",
          rejected.length],["members","Members",members.length],["activity","Activity",activityLog.length]].map(([id,label,count]) => (
          <button key={id} className={"admin-tab"+(tab===id?" admin-tab-on":"")} onClick={()=>setTab(id)}>
            {label} <span className="tab-count">{count}</span>
          </button>
        ))}
      </div>
      {tab === "activity" ? (
        <div className="admin-list">
          <div className="activity-note-box">
            <textarea className="input textarea" rows={2} value={noteText}
              onChange={e=>setNoteText(e.target.value)}
              placeholder="Add a note..." />
            <Btn onClick={() => {
              if (!noteText.trim()) return;
              addActivity("note", "📝 " + noteText.trim());
              setNoteText("");
            }}>Add note</Btn>
          </div>
          {activityLog.length === 0 && <div className="empty"><p className="empty-title">No activity yet</p><p>Actions like approvals, rejections and Featured toggles will appear here.</p></div>}
          {activityLog.map((a,i) => (
            <div key={i} className="activity-item">
              <span className="activity-text">{a.text}</span>
              <span className="activity-date">{new Date(a.date).toLocaleDateString("en-GB")} {new Date(a.date).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})}</span>
            </div>
          ))}
        </div>
      ) : tab === "members" ? (
        <div className="admin-list">
          {loadingMembers && <div className="empty"><p>Loading members...</p></div>}
          {!loadingMembers && members.length === 0 && <div className="empty"><p className="empty-title">No members yet</p></div>}
          {members.map((m,i) => (
            <div key={i} className="admin-card">
              <div className="admin-card-info">
                <strong>{m.email}</strong>
                <span>{m.town || "Town not set"}</span>
                <span style={{fontSize:11,color:"#9A9486"}}>
                  Joined {m.signupAt ? new Date(m.signupAt).toLocaleDateString("en-GB") : "unknown"}
                  {m.lastSeen && " · Last seen " + new Date(m.lastSeen).toLocaleDateString("en-GB")}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
      <div className="admin-list">
        {list.length === 0 && <div className="empty"><p className="empty-title">Nothing here</p></div>}
        {list.map(c => (
          <div key={c.id} className="admin-card">
            <div className="admin-card-info">
              <strong>{c.name}</strong>
              <span>{CATEGORIES.find(cat=>cat.id===c.category)?.label} · {c.town}</span>
              <span>{c.email} · {c.phone}</span>
              {c.blurb && <p className="admin-blurb">{c.blurb}</p>}
              <div style={{display:"flex",gap:6,marginTop:4,flexWrap:"wrap"}}>
                {c.status==="approved" && <span className={"status-badge status-approved"}>Live</span>}
                {c.featured && <span className="cc-badge cc-badge-sp" style={{position:"static",fontSize:11}}>⭐ Featured</span>}
                {c.verified && <span style={{fontSize:11,fontWeight:700,color:"#2D9B6F",background:"#F0FDF4",borderRadius:20,padding:"2px 8px"}}>✓ Verified</span>}
                {c.paid_verification && <span style={{fontSize:11,fontWeight:700,color:"#1B3A4B",background:"#F0EAD8",borderRadius:20,padding:"2px 8px"}}>£ Fee paid</span>}
                {c.paid_verification && c.verified && <span style={{fontSize:11,fontWeight:700,color:"#fff",background:"#2D9B6F",borderRadius:20,padding:"2px 8px"}}>✓ Vetted</span>}
              </div>
            </div>
            <div className="admin-card-actions">
              <Btn onClick={() => setSelectedCompany(c)}>View →</Btn>
              {c.status==="pending" && (
                <>
                  <Btn onClick={() => approve(c)}>Approve</Btn>
                  <Btn variant="secondary" onClick={() => reject(c)}>Reject</Btn>
                </>
              )}
              {c.status==="approved" && (
                <Btn variant="secondary" onClick={() => onToggleFeatured(c)}>
                  {c.featured ? "Remove Featured" : "⭐ Make Featured"}
                </Btn>
              )}
              {c.status==="approved" && (
                <Btn variant="secondary" onClick={() => onToggleVerified(c)}>
                  {c.verified ? "Remove Verified" : "✓ Mark Verified"}
                </Btn>
              )}
              <Btn variant="secondary" onClick={(e) => { e.stopPropagation(); onRemove(c.id); }}>Remove</Btn>
            </div>
          </div>
        ))}
      </div>
      )}
      </>
      )}
    </div>
  );
}

// ---
function ForBusinessScreen({ onClose, onGetStarted }) {
  return (
    <div className="screen">
      <Topbar onBack={onClose} title="For Businesses" light />
      <div className="legal-body">
        <div className="fb-hero">
          <Building2 size={40} strokeWidth={1.5} color="#C75D3A" />
          <h2 className="fb-title">Reach English-speaking residents on the Costa del Sol</h2>
          <p className="fb-sub">CostaMate connects expats and long-stay residents with trusted local companies. List your business free and start receiving enquiries today.</p>
          <div style={{background:"#F0FDF4",border:"1.5px solid #86EFAC",borderRadius:12,padding:"12px 16px",marginTop:8,textAlign:"center"}}>
            <strong style={{color:"#166534",fontSize:15}}>100% free to list. No card required. No hidden charges.</strong>
            <p style={{fontSize:12,color:"#166534",margin:"4px 0 0"}}>Optional upgrade available if and when you want it — never required.</p>
          </div>
        </div>

        <div className="fb-section">
          <h3 className="fb-section-title">How it works</h3>
          <div className="fb-step"><span className="fb-step-num">1</span><div><strong>Submit your listing — free</strong><p>Tell us about your company — what you do, where you're based, and how far you travel. No payment needed.</p></div></div>
          <div className="fb-step"><span className="fb-step-num">2</span><div><strong>Verify your identity — free</strong><p>Complete a quick AI-powered identity check via Veriff. Takes 2-3 minutes and adds a Verified badge to your listing.</p></div></div>
          <div className="fb-step"><span className="fb-step-num">3</span><div><strong>Get approved</strong><p>We review your listing within 48 hours. Once approved you're live and visible to residents across the Costa del Sol.</p></div></div>
          <div className="fb-step"><span className="fb-step-num">4</span><div><strong>Receive enquiries — free</strong><p>Residents send you quote requests directly to your email. Completely free, forever.</p></div></div>
        </div>

        <div className="fb-section">
          <h3 className="fb-section-title">Pricing</h3>
          <div className="fb-plan" style={{borderColor:"#86EFAC",background:"#F0FDF4"}}>
            <div className="fb-plan-header">
              <span className="fb-plan-name">Standard</span>
              <span className="fb-plan-price" style={{color:"#166534"}}>Free forever</span>
            </div>
            <p style={{fontSize:12,color:"#166534",fontWeight:700,marginBottom:8}}>No card required. No contract. No hidden charges.</p>
            <ul className="fb-plan-features">
              <li>✓ Full company listing</li>
              <li>✓ Verified badge (after identity check)</li>
              <li>✓ Receive quote requests by email</li>
              <li>✓ Company dashboard</li>
              <li>✓ Photo and description</li>
              <li>✓ Free identity verification</li>
            </ul>
          </div>
          <div className="fb-plan fb-plan-featured">
            <div className="fb-plan-badge">⭐ Optional upgrade</div>
            <div className="fb-plan-header">
              <span className="fb-plan-name">Featured</span>
              <span className="fb-plan-price">€25<span style={{fontSize:13,fontWeight:400}}>/mo</span></span>
            </div>
            <div style={{background:"#FEF3C7",borderRadius:8,padding:"6px 10px",fontSize:12,fontWeight:700,color:"#92400E",marginBottom:10}}>🎁 First 30 days free — no card charged until day 31</div>
            <ul className="fb-plan-features">
              <li>✓ Everything in Standard</li>
              <li>✓ Top of search results</li>
              <li>✓ Featured badge</li>
              <li>✓ Emergency alert system</li>
              <li>✓ Priority support</li>
              <li>✓ Cancel any time — no commitment</li>
            </ul>
          </div>
        </div>

        <div className="fb-section">
          <h3 className="fb-section-title">Why CostaMate?</h3>
          <div className="fb-why"><ShieldCheck size={20} strokeWidth={2} color="#2D9B6F" /><p>AI-powered identity verification builds trust with residents</p></div>
          <div className="fb-why"><Users size={20} strokeWidth={2} color="#1B3A4B" /><p>Targeted audience — English-speaking expats actively looking for services</p></div>
          <div className="fb-why"><Zap size={20} strokeWidth={2} color="#C75D3A" /><p>Emergency alerts put Featured companies first when residents need urgent help</p></div>
          <div className="fb-why"><Star size={20} strokeWidth={2} color="#F5C842" /><p>Stand out in a crowded market with a verified, professional listing</p></div>
        </div>

        <Btn full onClick={onGetStarted} style={{marginBottom:16}}>List your company free →</Btn>
        <p style={{fontSize:12,color:"#9A9486",textAlign:"center",marginBottom:24}}>Questions? Email Admin@costamate.com</p>
      </div>
    </div>
  );
}

function AboutScreen({ onClose }) {
  return (
    <div className="screen">
      <Topbar onBack={onClose} title="About CostaMate" light />
      <div className="about-body">

        <div className="about-hero">
          <div className="about-logo-row">
            <img src={LOGO} alt="" className="tb-logo" style={{height:40}} />
            <span style={{fontFamily:"'Fraunces',serif",fontSize:26,fontWeight:600,
              color:"#FAF6EF",letterSpacing:"-0.02em"}}>
              Costa<span style={{color:"#C75D3A"}}>Mate</span>
            </span>
          </div>
          <h2 className="about-headline">
            The Costa del Sol's trusted English-speaking directory.
          </h2>
          <p className="about-tagline-text">Let's get it sorted.</p>
        </div>

        <div className="about-card">
          <p className="about-card-text">
            Finding reliable local help on the Costa del Sol has always meant
            asking around on Facebook, hoping someone knows someone, or taking
            a chance on a company you know nothing about.
          </p>
          <p className="about-card-text" style={{marginTop:10}}>
            CostaMate changes that. Every company is identity-verified using 
            AI-powered technology before listing. Every company speaks English — 
            no language barrier, ever. And the emergency feature connects you 
            with verified local help 24 hours a day.
          </p>
        </div>

        <div className="about-section-title">How it works</div>
        <div className="about-steps">
          <div className="about-step">
            <div className="about-step-num" style={{background:"#1B3A4B"}}>1</div>
            <div className="about-step-content">
              <strong>Share your location</strong>
              <p>Allow location access and set your search radius. We show you
                vetted companies within your area — anywhere on the Costa del Sol.</p>
            </div>
          </div>
          <div className="about-step">
            <div className="about-step-num" style={{background:"#C75D3A"}}>2</div>
            <div className="about-step-content">
              <strong>Browse and request</strong>
              <p>Search by category, view verified company profiles, and send a free quote request
                directly to any company by email. No account needed.</p>
            </div>
          </div>
          <div className="about-step">
            <div className="about-step-num" style={{background:"#2D9B6F"}}>3</div>
            <div className="about-step-content">
              <strong>Get sorted</strong>
              <p>The company contacts you directly. No middleman, no commission,
                no language barrier. Just sorted.</p>
            </div>
          </div>
        </div>

        <div className="about-em-card">
          <div className="about-em-head">
            <Zap size={18} strokeWidth={2} color="#fff" />
            <strong>24hr Emergency</strong>
          </div>
          <p>Need urgent help right now? Tap the emergency button, tell us
            what you need, and we'll message every available emergency company
            in your area simultaneously. First to reply gets the job.</p>
        </div>

        <div className="about-section-title">Why trust CostaMate?</div>
        <div className="about-trust">
          <div className="about-trust-item">
            <ShieldCheck size={20} strokeWidth={2} color="#2D9B6F" />
            <div>
              <strong>Every company vetted</strong>
              <p>We check every business before they appear. No cowboys.</p>
            </div>
          </div>
          <div className="about-trust-item">
            <Star size={20} strokeWidth={2} color="#F5C842" />
            <div>
              <strong>Real reviews only</strong>
              <p>Every review is from a verified resident who used the company.</p>
            </div>
          </div>
          <div className="about-trust-item">
            <Users size={20} strokeWidth={2} color="#1B3A4B" />
            <div>
              <strong>Always in English</strong>
              <p>Every listed company speaks English. No language barrier, ever.</p>
            </div>
          </div>
          <div className="about-trust-item">
            <CheckCircle size={20} strokeWidth={2} color="#C75D3A" />
            <div>
              <strong>Free for residents</strong>
              <p>Browsing and sending quote requests is always completely free.</p>
            </div>
          </div>
        </div>

        <div className="about-towns">
          <p className="about-towns-label">Covering the Costa del Sol</p>
          <div className="about-towns-grid">
            {TOWNS.map(t => (
              <div key={t} className="about-town-pill">
                <MapPin size={10} strokeWidth={2} /> {t}
              </div>
            ))}
            <div className="about-town-pill about-town-pill-more">
              + surrounding areas
            </div>
          </div>
        </div>

        <div className="about-footer">
          <p>Operated by <strong>Prima Training Limited</strong></p>
          <p>Companies House 05238520 · VAT GB307847583</p>
          <p>Admin@costamate.com</p>
          <p className="about-spanish">Disponible en Español — próximamente</p>
        </div>

      </div>
    </div>
  );
}

function TermsScreen({ onClose }) {
  const TERMS = [
    {
      title: "1. About CostaMate",
      body: "CostaMate is operated by Prima Training Limited, a company registered in England "
        + "and Wales (Companies House 05238520, VAT GB307847583). Registered address available "
        + "on request. Contact us at Admin@costamate.com.",
    },
    {
      title: "2. What CostaMate is — and is not",
      body: "CostaMate is an introduction and directory service only. We connect "
        + "English-speaking residents on the Costa del Sol with independent local service "
        + "companies. CostaMate is not a party to any contract, agreement or transaction "
        + "between a resident and a listed company. We do not provide, arrange, supervise, "
        + "guarantee or take any responsibility for any service carried out by any listed company.",
    },
    {
      title: "3. No contract with CostaMate",
      body: "Any contract for services is made directly and solely between you and the company "
        + "you engage. CostaMate has no involvement in, and accepts no liability for, the "
        + "performance, quality, pricing, safety or outcome of any such services. We are "
        + "strictly an intermediary introduction platform.",
    },
    {
      title: "4. Company vetting and identity verification",
      body: "All companies listed on CostaMate are required to complete identity verification "
        + "powered by Veriff, a third-party AI identity verification provider. Verification "
        + "confirms the identity of the business owner or representative. A 'Verified' badge "
        + "is displayed on listings that have passed this process. However, verification does "
        + "not constitute an endorsement, warranty or guarantee of any company, its staff, "
        + "qualifications, licences, insurance or the quality of its work. It is your "
        + "responsibility to satisfy yourself that any company you engage is suitably qualified, "
        + "insured and licensed. Always obtain a written quote before work commences.",
    },
    {
      title: "5. Featured listings and free trial",
      body: "Companies may upgrade to a Featured listing at €25 per month (excluding VAT where "
        + "applicable), billed monthly via Stripe. New companies receive a 30-day free trial of "
        + "the Featured plan. No charge is made until day 31. After the free trial, the monthly "
        + "fee of €25 is charged automatically to the payment method provided. Featured companies "
        + "appear at the top of search results with a Featured badge and are included in the "
        + "emergency alert system. Subscriptions can be cancelled at any time via Stripe; "
        + "cancellation takes effect at the end of the current billing period and no further "
        + "charges will be made. CostaMate reserves the right to change Featured pricing with "
        + "30 days notice.",
    },
    {
      title: "6. Limitation of liability",
      body: "To the fullest extent permitted by law, Prima Training Limited shall not be liable "
        + "for any loss, damage, injury, cost or expense of any kind arising from: (a) any "
        + "service provided or not provided by a listed company; (b) any dispute between a "
        + "resident and a listed company; (c) any inaccuracy in a company listing; (d) your "
        + "reliance on any information on this platform; or (e) any interruption or "
        + "unavailability of the platform. Our total liability in any circumstances shall "
        + "not exceed £100.",
    },
    {
      title: "7. Emergency services",
      body: "The emergency feature sends SMS alerts to Featured companies on your behalf. "
        + "CostaMate does not guarantee response times or availability of any company. "
        + "For life-threatening emergencies always call 112. CostaMate accepts no liability "
        + "for any loss arising from use or non-use of the emergency feature.",
    },
    {
      title: "8. Your responsibilities",
      body: "You must be 18 or over to use CostaMate. You agree to use the platform only for "
        + "lawful purposes. You must not submit false or misleading information, misuse the quote "
        + "request system, or attempt to damage the reputation of any listed company without "
        + "proper grounds. We reserve the right to remove any account or listing at our "
        + "sole discretion.",
    },
    {
      title: "9. Company listings",
      body: "Companies listed on CostaMate are independent businesses. They are not employees, "
        + "agents or partners of Prima Training Limited. Listed companies are responsible for "
        + "their own compliance with all applicable laws including tax, employment, health and "
        + "safety, and insurance obligations. We reserve the right to remove any listing at "
        + "any time without notice or liability.",
    },
    {
      title: "10. Payments and pricing",
      body: "Browsing and sending quote requests is free for residents. Standard company listings "
        + "are free. Featured listings include a 30-day free trial; after which €25/month is charged "
        + "automatically via Stripe until cancelled. All prices are exclusive of VAT where "
        + "applicable. Payments are processed securely via Stripe. CostaMate does not store "
        + "payment card details.",
    },
    {
      title: "11. Third-party services",
      body: "CostaMate uses third-party services including Veriff (identity verification), "
        + "Stripe (payments), Cloudinary (image storage) and EmailJS (email delivery). "
        + "Use of these services is subject to their respective terms and privacy policies. "
        + "CostaMate is not responsible for the availability or performance of these services.",
    },
    {
      title: "12. Intellectual property",
      body: "All content, design, trademarks and branding on CostaMate are owned by or licensed "
        + "to Prima Training Limited. You may not copy, reproduce or distribute any content "
        + "from this platform without our prior written consent.",
    },
    {
      title: "13. Privacy and data",
      body: "Your personal data is processed in accordance with our Privacy Policy. By using "
        + "CostaMate you consent to the collection and use of your data as described therein. "
        + "We do not sell your data to third parties. Identity verification data is processed "
        + "by Veriff in accordance with their privacy policy at veriff.com/privacy.",
    },
    {
      title: "14. Governing law",
      body: "These terms are governed by the laws of England and Wales. Any disputes shall be "
        + "subject to the exclusive jurisdiction of the courts of England and Wales, without "
        + "prejudice to your rights as a consumer under applicable EU or Spanish law.",
    },
    {
      title: "15. Changes to these terms",
      body: "We may update these terms at any time. We will notify users of material changes "
        + "where reasonably practicable. Continued use of CostaMate after changes are posted "
        + "constitutes acceptance of the revised terms.",
    },
    {
      title: "16. Contact",
      body: "For any queries regarding these terms please contact us at Admin@costamate.com. "
        + "Prima Training Limited. Companies House 05238520. VAT GB307847583. "
        + "We aim to respond within 5 business days.",
    },
  ];

  return (
    <div className="screen">
      <Topbar onBack={onClose} title="Terms & Conditions" light />
      <div className="legal-body">
        <div className="legal-header">
          <p className="legal-updated">Last updated July 2026</p>
          <p className="legal-operator">
            Operated by <strong>Prima Training Limited</strong>
          </p>
          <p className="legal-operator">
            Companies House 05238520 · VAT GB307847583
          </p>
          <div className="legal-notice">
            <ShieldCheck size={16} strokeWidth={2} color="#2D9B6F" />
            <p>
              CostaMate is an introduction service only. We are not a party
              to any contract between residents and companies.
            </p>
          </div>
        </div>
        {TERMS.map((t, i) => (
          <div key={i} className="legal-section">
            <h3>{t.title}</h3>
            <p>{t.body}</p>
          </div>
        ))}
        <div className="legal-footer">
          <p>These terms do not affect your statutory rights.</p>
          <p>Admin@costamate.com</p>
        </div>
      </div>
    </div>
  );
}

function PrivacyScreen({ onClose }) {
  return (
    <div className="screen">
      <Topbar onBack={onClose} title="Privacy Policy" light />
      <div className="legal-body">
        <p className="legal-updated">Prima Training Limited · Admin@costamate.com</p>
        {PRIVACY_DATA.map(([h,b]) => (
          <div key={h} className="legal-section">
            <h3>{h}</h3><p>{b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

function ContactScreen({ onClose }) {
  const [name,setName]=useState("");
  const [email,setEmail]=useState("");
  const [subject,setSubject]=useState("General enquiry");
  const [msg,setMsg]=useState("");
  const [sending,setSending]=useState(false);
  const [sent,setSent]=useState(false);
  const send = () => {
    if(!name||!email||!msg) return;
    setSending(true);
    sendEmail({to_email:ADMIN_EMAIL,from_email:email,subject:"[CostaMate] "+subject+" - "+name,
      message:"From: "+name+" <"+email+">\n\n"+msg,from_name:name});
    setTimeout(() => { setSending(false); setSent(true); }, 800);
  };
  return (
    <div className="screen">
      <Topbar onBack={onClose} title="Get in touch" light />
      <div className="portal-body">
        {sent ? (
          <div className="sent-state">
            <CheckCircle size={36} strokeWidth={1.5} color="#2D9B6F" />
            <p>Message sent! We'll reply to {email} within one business day.</p>
            <Btn onClick={onClose}>Done</Btn>
          </div>
        ) : (
          <>
            <Field label="Your name"><input className="input" value={name} onChange={e=>setName(e.target.value)} /></Field>
            <Field label="Email"><input className="input" type="email" value={email} onChange={e=>setEmail(e.target.value)} /></Field>
            <Field label="Subject">
              <select className="input" value={subject} onChange={e=>setSubject(e.target.value)}>
                {CONTACT_SUBJECTS.map(s=><option key={s}>{s}</option>)}
              </select>
            </Field>
            <Field label="Message">
              <textarea className="input textarea" rows={5} value={msg} onChange={e=>setMsg(e.target.value)} />
            </Field>
            <Btn full onClick={send} disabled={sending||!name||!email||!msg}>
              {sending ? "Sending..." : "Send message"}
            </Btn>
          </>
        )}
      </div>
    </div>
  );
}

// ---
function ProfileScreen({ user, onSignOut, onClose, companies }) {
  const [tab, setTab] = useState("details");
  const [name, setName] = useState(user.name||"");
  const [pw, setPw] = useState({cur:"",new1:"",new2:""});
  const [pwErr, setPwErr] = useState("");
  const [pwOk, setPwOk] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [favourites, setFavourites] = useLocal("cm:favourites", []);
  const [browseCategory, setBrowseCategory] = useState(null);
  const history = JSON.parse(localStorage.getItem("cm:history")||"[]");
  const favouriteCompanies = (companies||[]).filter(c => favourites.includes(c.id));

  const saveDetails = async () => {
    setSaving(true);
    const key = "cm:acc:"+user.email.replace(/[^a-z0-9@._-]/g,"");
    try {
      const s = localStorage.getItem(key);
      if (s) {
        const acc = JSON.parse(s);
        acc.name = name;
        localStorage.setItem(key, JSON.stringify(acc));
      }
    } catch {}
    setSaving(false); setSaved(true);
    setTimeout(()=>setSaved(false),2000);
  };

  const changePw = async () => {
    setPwErr(""); setPwOk(false);
    if (pw.new1.length < 6) { setPwErr("New password must be 6+ characters."); return; }
    if (pw.new1 !== pw.new2) { setPwErr("Passwords don't match."); return; }
    const key = "cm:acc:"+user.email.replace(/[^a-z0-9@._-]/g,"");
    try {
      const s = localStorage.getItem(key);
      if (!s) { setPwErr("Account not found."); return; }
      const acc = JSON.parse(s);
      if (acc.pw !== btoa(pw.cur)) { setPwErr("Current password incorrect."); return; }
      acc.pw = btoa(pw.new1);
      localStorage.setItem(key, JSON.stringify(acc));
      setPw({cur:"",new1:"",new2:""}); setPwOk(true);
    } catch { setPwErr("Could not update. Try again."); }
  };

  return (
    <div className="screen">
      <Topbar onBack={onClose} title="My Account"
        right={<button className="tb-signout" onClick={onSignOut}><LogOut size={16} strokeWidth={2} /></button>} light />
      <div className="profile-hero">
        <div className="profile-avatar">{(user.name||user.email)[0].toUpperCase()}</div>
        <div><p className="profile-name">{user.name||"Member"}</p><p className="profile-email">{user.email}</p></div>
      </div>
      <div className="profile-tabs">
        {["details","password","favourites","history"].map(t=>(
          <button key={t} className={"profile-tab"+(tab===t?" profile-tab-on":"")} onClick={()=>setTab(t)}>
            {t==="details"?"My Details":t==="password"?"Password":t==="favourites"?"Saved":"History"}
          </button>
        ))}
      </div>
      <div className="portal-body">
        {tab==="details" && (
          <>
            <Field label="Full name"><input className="input" value={name} onChange={e=>setName(e.target.value)} /></Field>
            <Field label="Email"><input className="input" value={user.email} disabled style={{opacity:0.5}} /></Field>
            <Btn full onClick={saveDetails} disabled={saving}>{saving?"Saving...":saved?"Saved!":"Save changes"}</Btn>
          </>
        )}
        {tab==="password" && (
          <>
            {pwOk && <div className="success-banner"><Check size={14} strokeWidth={2} /> Password updated.</div>}
            <Field label="Current password"><input className="input" type="password" value={pw.cur}
              onChange={e=>setPw(p=>({...p,cur:e.target.value}))} /></Field>
            <Field label="New password"><input className="input" type="password" value={pw.new1}
              onChange={e=>setPw(p=>({...p,new1:e.target.value}))} /></Field>
            <Field label="Confirm new password"><input className="input" type="password" value={pw.new2}
              onChange={e=>setPw(p=>({...p,new2:e.target.value}))} /></Field>
            {pwErr && <p className="err">{pwErr}</p>}
            <Btn full onClick={changePw}>Update password</Btn>
          </>
        )}
        {tab==="favourites" && (
          <>
            {favouriteCompanies.length === 0
              ? <div className="portal-empty">
                  <Star size={32} strokeWidth={1.5} color="#1B3A4B" />
                  <h3>No saved companies yet</h3>
                  <p>Tap the ★ on any company listing to save it here for quick access.</p>
                </div>
              : favouriteCompanies.map(c => (
                  <div key={c.id} className="history-row" style={{alignItems:"center"}}>
                    {c.photos?.[0] && <img src={c.photos[0]} alt="" style={{width:36,height:36,borderRadius:8,objectFit:"cover",flexShrink:0}} />}
                    <div className="history-info">
                      <strong>{c.name}</strong>
                      <span>{CATEGORIES.find(cat=>cat.id===c.category)?.label}</span>
                    </div>
                    <button onClick={()=>setFavourites(prev=>prev.filter(id=>id!==c.id))}
                      style={{background:"none",border:"none",color:"#F5C842",fontSize:20,cursor:"pointer"}}>★</button>
                  </div>
                ))
            }
          </>
        )}
        {tab==="history" && (
          <>
            {history.length===0
              ? <div className="empty"><p className="empty-title">No searches yet</p></div>
              : history.map((h,i)=>(
                  <div key={i} className="history-row">
                    <Clock size={14} strokeWidth={2} color="#9A9486" />
                    <div className="history-info">
                      <strong>{CATEGORIES.find(c=>c.id===h.category)?.label||"All services"}</strong>
                      <span>{h.town||"All towns"}</span>
                    </div>
                    <span className="history-date">{timeAgo(h.date)}</span>
                  </div>
                ))}
            {history.length>0 && (
              <Btn variant="secondary" full onClick={()=>localStorage.removeItem("cm:history")}>Clear history</Btn>
            )}
          </>
        )}
      </div>
    </div>
  );
}

// ---
function EmergencyScreen({ companies, town, onBack }) {
  const [category, setCategory] = useState(null);
  const [sent, setSent] = useState(false);
  const [name, setName] = useState("");
  const [issue, setIssue] = useState("");
  const [residentPhone, setResidentPhone] = useState("");
  const [sending, setSending] = useState(false);

  const EMERGENCY_CATS = [
    {id:"plumbing",label:"Plumber",icon:"🔧",match:"trades"},
    {id:"electrical",label:"Electrician",icon:"⚡",match:"trades"},
    {id:"locksmith",label:"Locksmith",icon:"🔑",match:"trades"},
    {id:"aircon",label:"Aircon",icon:"❄️",match:"trades"},
    {id:"pool",label:"Pool",icon:"🏊",match:"home_garden"},
    {id:"cleaning",label:"Cleaning",icon:"🧹",match:"home_garden"},
    {id:"pest",label:"Pest control",icon:"🐛",match:"home_garden"},
    {id:"vet",label:"Vet",icon:"🐾",match:"animals"},
    {id:"medical",label:"Medical",icon:"🏥",match:"health"},
    {id:"realestate",label:"Real Estate",icon:"🏠",match:"realestate"},
    {id:"other",label:"Other",icon:"🆘",match:null},
  ];

  const sel = EMERGENCY_CATS.find(c => c.id === category);

  const filtered = companies.filter(c => {
    if (!category || category === "other") return true;
    return c.category === sel.match;
  });

  const blast = async () => {
    if (!name || !issue) return;
    setSending(true);
    const msg = "EMERGENCY — CostaMate\n\n" +
      "Type: " + (sel ? sel.label : "General") + "\n" +
      "Name: " + name + "\n" +
      (residentPhone ? "Resident phone: " + residentPhone + "\n" : "") +
      "Issue: " + issue + "\n" +
      (town ? "Location: " + town + "\n" : "") +
      "\nReply YES to accept. First to reply gets the job.";

    // SMS Featured companies via Twilio (using their mobile/SMS number)
    const featuredCompanies = filtered.filter(c => c.featured && (c.whatsapp || c.phone));
    if (featuredCompanies.length > 0) {
      try {
        const smsCompanies = featuredCompanies.map(c => ({...c,
          phone: c.whatsapp || c.phone,
          pendingEmergencyResidentPhone: residentPhone,
          pendingEmergency: true
        }));
        await apiCall("sendEmergencySMS", { companies: smsCompanies, message: msg });
      } catch(e) { console.error("SMS error:", e); }
    }

    // WhatsApp fallback for non-featured companies with whatsapp
    const nonFeatured = filtered.filter(c => !c.featured && c.whatsapp);
    const encodedMsg = encodeURIComponent(msg);
    nonFeatured.forEach((c, i) => {
      const num = c.whatsapp.replace(/[^0-9]/g, "");
      setTimeout(() => {
        window.open("https://wa.me/" + num + "?text=" + encodedMsg, "_blank");
      }, i * 500);
    });

    sendEmail({
      to_email: ADMIN_EMAIL,
      subject: "EMERGENCY — " + (sel ? sel.label : "General") + " — " + (town || "unknown"),
      message: "Emergency from " + name + "\nPhone: " + (residentPhone || "not given") +
        "\nType: " + (sel ? sel.label : "General") +
        "\nIssue: " + issue + "\nTown: " + (town || "not given") +
        "\nSMS sent to " + featuredCompanies.length + " Featured companies." +
        "\nWhatsApp sent to " + nonFeatured.length + " other companies.",
      from_name: name,
    });
    setSending(false);
    setSent(true);
  };

  // Step 1 — pick category
  if (!category) return (
    <div className="screen em-screen">
      <header className="em-topbar">
        <button className="tb-back" onClick={onBack}
          style={{background:"rgba(255,255,255,0.15)"}}>
          <ArrowLeft size={18} strokeWidth={2} />
        </button>
        <span className="em-topbar-title">What do you need?</span>
        <span />
      </header>
      <div className="em-hero" style={{paddingBottom:20}}>
        <Zap size={28} strokeWidth={1.5} color="#fff" />
        <p className="em-sub">Choose the type of help you need.</p>
      </div>
      <div className="em-cat-grid">
        {EMERGENCY_CATS.map(c => (
          <button key={c.id} className="em-cat-btn" onClick={() => setCategory(c.id)}>
            <span className="em-cat-icon">{c.icon}</span>
            <span>{c.label}</span>
          </button>
        ))}
      </div>
      <div className="em-112">
        <span>Life-threatening?</span>
        <a href="tel:112" className="em-112-link">Call 112</a>
      </div>
    </div>
  );

  // Step 2 — send blast
  return (
    <div className="screen em-screen">
      <header className="em-topbar">
        <button className="tb-back" onClick={() => setSent(false) || setCategory(null)}
          style={{background:"rgba(255,255,255,0.15)"}}>
          <ArrowLeft size={18} strokeWidth={2} />
        </button>
        <span className="em-topbar-title">
          {sel ? sel.icon + " " + sel.label : "Emergency"}
        </span>
        <span />
      </header>

      {!sent ? (
        <div className="em-body">
          <div className="em-hero">
            <h1 className="em-title">I need help now</h1>
            <p className="em-sub">
              {filtered.length > 0
                ? "We'll message all " + filtered.length + " emergency " +
                  (sel ? sel.label.toLowerCase() : "") +
                  " companies" + (town ? " in " + town : "") +
                  ". First to reply gets the job."
                : "No emergency companies found in this category."}
            </p>
          </div>

          {filtered.length === 0 ? (
            <div className="em-no-companies">
              <p style={{fontWeight:700,marginBottom:8}}>No emergency companies available yet.</p>
              <p style={{fontSize:13,opacity:0.8}}>We're growing our network of Featured emergency companies in this area. In the meantime, try calling 112 for life-threatening emergencies or search our directory for a company to contact directly.</p>
              <Btn onClick={() => setCategory(null)} variant="secondary" full style={{marginTop:12}}>
                Choose different type
              </Btn>
            </div>
          ) : (
            <div className="em-form">
              <Field label="Your name">
                <input className="input" value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="So companies know who to call" />
              </Field>
              <Field label="Your mobile number" sub="companies will call/text you back">
                <input className="input" type="tel" value={residentPhone}
                  onChange={e => setResidentPhone(e.target.value)}
                  placeholder="+34 600 000 000" />
              </Field>
              <Field label="What's the problem?">
                <textarea className="input textarea" rows={3} value={issue}
                  onChange={e => setIssue(e.target.value)}
                  placeholder={sel ? "e.g. " + (
                    sel.id==="plumbing" ? "Burst pipe, water flooding kitchen..." :
                    sel.id==="electrical" ? "No power, tripped fuse board..." :
                    sel.id==="locksmith" ? "Locked out, key broken in lock..." :
                    sel.id==="aircon" ? "Aircon stopped working, 35 degrees..." :
                    sel.id==="pool" ? "Pool pump broken, water turning green..." :
                    "Describe what you need..."
                  ) : "Describe what you need..."} />
              </Field>
              <div className="em-companies-preview">
                <p className="em-companies-label">
                  Sending to {filtered.length} {sel ? sel.label.toLowerCase() : ""} companies:
                </p>
                {filtered.map(c => (
                  <div key={c.id} className="em-company-row">
                    <Zap size={12} strokeWidth={2} color="#C0392B" />
                    <span>{c.name}</span>
                  </div>
                ))}
              </div>
              <button className="em-blast-btn" onClick={blast}
                disabled={sending || !name || !issue}>
                <Zap size={18} strokeWidth={2} />
                {sending ? "Sending..." : "Send to all — first to reply gets the job"}
              </button>
              <p className="em-disclaimer">
                Opens WhatsApp for each company. First to respond gets the job.
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className="em-body">
          <div className="em-success">
            <CheckCircle size={48} strokeWidth={1.5} color="#2D9B6F" />
            <h2>Messages sent!</h2>
            <p>
              Your emergency has been sent to {filtered.filter(c=>c.featured && c.phone).length} Featured emergency companies via SMS.
              The first to respond will contact you directly.
            </p>
            <p className="em-reminder">Keep your phone close — expect a reply within minutes.</p>
            <Btn onClick={onBack} full>Done</Btn>
          </div>
        </div>
      )}
      <div className="em-112">
        <span>Life-threatening?</span>
        <a href="tel:112" className="em-112-link">Call 112</a>
      </div>
    </div>
  );
}

function BottomNav({ onAdmin, onContact, onAbout, view }) {
  if (["admin", "admin-auth", "portal", "portal-auth", "signin"].includes(view)) return null;
  return (
    <div className="bottom-nav">
      <button onClick={onAbout}>
        <ShieldCheck size={16} strokeWidth={2} />
        <span>About</span>
      </button>
      <button onClick={onContact}>
        <Mail size={16} strokeWidth={2} />
        <span>Contact</span>
      </button>
      <button onClick={onAdmin}>
        <Users size={16} strokeWidth={2} />
        <span>Admin</span>
      </button>
    </div>
  );
}

function CookieBanner({ onAccept, onEssential }) {
  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p className="cookie-text">
          We use cookies to remember your location and preferences.
          <button className="cookie-link" onClick={onEssential}> Privacy policy</button>
        </p>
        <div className="cookie-btns">
          <button className="cookie-ess" onClick={onEssential}>Essential only</button>
          <button className="cookie-acc" onClick={onAccept}>Accept all</button>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  React.useEffect(() => {
    const s = document.createElement("style");
    s.textContent = CSS;
    document.head.appendChild(s);
    const ejs = document.createElement("script");
    ejs.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js";
    ejs.onload = () => { if (typeof window.emailjs !== "undefined") window.emailjs.init(EMAILJS_KEY); };
    document.head.appendChild(ejs);
  }, []);
  const [companies, setCompanies] = useLocal("cm:companies", []);

  // Always load fresh from Airtable on mount — never rely on stale cache
  React.useEffect(() => {
    const load = async () => {
      try {
        const atCompanies = await fbGetCompanies();
        setCompanies(atCompanies);
      } catch(e) {
        console.error("Could not load from Airtable:", e);
      }
    };
    load();
    // Also refresh every 5 minutes in case admin makes changes
    const interval = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);
  // Track referral code from URL
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) localStorage.setItem("cm:ref", ref);
  }, []);
  const [demoName, setDemoName] = useLocal("cm:demoname", null);
  const [showPreview, setShowPreview] = useLocal("cm:showpreview", false);
  // Public listings never include demo — demo only shown in admin
  const allCompanies = [...companies];
  // Admin-only preview list includes demo company
  const adminCompanies = [
    ...(showPreview ? [PREVIEW_COMPANY] : []),
    ...(demoName ? [{
      ...PREVIEW_COMPANY,
      id: "demo-live",
      name: demoName,
      sponsored: false,
      blurb: "Your company will appear here just like this once approved.",
    }] : []),
    ...companies
  ];
  const [view, setView] = useState("splash");
  const [ready, setReady] = useState(false);
  const [town, setTown] = useLocal("cm:town", null);
  const [userCoords, setUserCoords] = useLocal("cm:coords", null);
  const [searchRadius, setSearchRadius] = useLocal("cm:radius", 10);
  const [user, setUser] = useLocal("cm:user", null);
  const [activeCompany, setActiveCompany] = useState(null);
  const [cookies, setCookies] = useLocal('cm:cookies', null);
  const [quoteFor, setQuoteFor] = useState(null);
  const [overlay, setOverlay] = useState(null); // "about"|"terms"|"privacy"|"contact"
  const [portalUser, setPortalUser] = useState(null);
  const [adminUser, setAdminUser] = useState(null);
  const [favourites, setFavourites] = useLocal("cm:favourites", []);
  const [browseCategory, setBrowseCategory] = useState(null);

  const go = (v) => { setView(v); setActiveCompany(null); setQuoteFor(null); };

  // On mount, read localStorage and jump to correct screen immediately
  useEffect(() => {
    try {
      const savedUser = localStorage.getItem("cm:user");
      const savedTown = localStorage.getItem("cm:town");
      if (savedUser && savedTown) {
        const parsedUser = JSON.parse(savedUser);
        if (parsedUser && parsedUser.email) {
          setUser(parsedUser);
          setView("welcome");
        }
      } else if (savedTown) {
        setView("welcome");
      }
    } catch {}
    setReady(true);
  }, []);

  if (!ready) return <div style={{background:"#1B3A4B",width:"100%",height:"100vh"}} />;

  const cookieBanner = !cookies ? (
    <CookieBanner
      onAccept={() => setCookies("all")}
      onEssential={() => setCookies("essential")}
    />
  ) : null;

  // Show overlays over everything
  if (overlay === "about") return <>{cookieBanner}
    <AboutScreen onClose={() => setOverlay(null)} /><BottomNav onAdmin={() => go("admin-auth")} onCo
    ntact={() => setOverlay("contact")} onAbout={() => setOverlay("about")} view={view} /></>;
  if (overlay === "terms") return <>{cookieBanner}<TermsScreen onClose={() => setOverlay(null)} /></>;
  if (overlay === "privacy") return <>{cookieBanner}<PrivacyScreen onClose={() => setOverlay(null)} /></>;
  if (overlay === "contact") return <>{cookieBanner}<ContactScreen onClose={() => setOverlay(null)} /></>;
  if (overlay === "forbusiness") return <>{cookieBanner}<ForBusinessScreen onClose={() => setOverlay(null)} onGetStarted={() => { setOverlay(null); go("portal-auth"); }} /></>;

  if (view === "admin-auth") return (
    <AuthScreen admin onAuthed={u => { setAdminUser(u); go("admin"); }} onBack={() => go("splash")} />
  );

  if (view === "admin") {
    if (!adminUser) { go("admin-auth"); return null; }
    return (
      <AdminView
        companies={adminCompanies}
        onApprove={id => {
          const company = adminCompanies.find(c => c.id === id);
          fbUpdateCompany(id, {status:"approved", decidedAt:new Date().toISOString()});
          setCompanies(prev => prev.map(c => c.id===id?{...c,status:"approved",decidedAt:new Date().toISOString()}:c));
          if (company?.email) sendEmail({
            to_email: company.email,
            subject: "🎉 Your CostaMate listing is live — " + company.name,
            message: "Hi,\n\nGreat news! Your listing on CostaMate has been approved and is now live at costamate.com.\n\n" +
              "Residents across the Costa del Sol can now find you, view your profile and send quote requests directly to your email.\n\n" +
              "To get the most from CostaMate:\n" +
              "✓ Log into your company dashboard at costamate.com\n" +
              "✓ Keep your details up to date\n" +
              "✓ Consider upgrading to Featured (30 days free) for top placement and emergency alerts\n\n" +
              "Welcome to CostaMate!\n\nElla Stowell\nFounder, CostaMate\nAdmin@costamate.com",
            from_name: "CostaMate"
          });
        }}
        onReject={(id,r) => {
          fbUpdateCompany(id, {status:"rejected", rejectReason:r});
          setCompanies(prev => prev.map(c => c.id===id?{...c,status:"rejected",rejectReason:r}:c));
        }}
        onRemove={id => {
          fbDeleteCompany(id);
          setCompanies(prev => prev.filter(c => c.id!==id));
        }}
        onToggleFeatured={c => {
          const updated = {...c, featured: !c.featured};
          fbUpdateCompany(c.id, {featured: !c.featured});
          setCompanies(prev => prev.map(x => x.id===c.id ? updated : x));
        }}
        onToggleVerified={c => {
          const updated = {...c, verified: !c.verified};
          fbUpdateCompany(c.id, {verified: !c.verified});
          setCompanies(prev => prev.map(x => x.id===c.id ? updated : x));
        }}
        showPreview={showPreview}
        onTogglePreview={() => setShowPreview(p => !p)}
        onBack={() => go("splash")}
      />
    );
  }

  if (view === "portal-auth") return (
    <AuthScreen onAuthed={u => { setPortalUser(u); go("portal"); }} onBack={() => go("splash")} />
  );

  if (view === "portal") {
    if (!portalUser) { go("portal-auth"); return null; }
    return (
      <PortalView
        companies={allCompanies}
        allCompanies={allCompanies}
        user={portalUser}
        onSubmit={c => {
          apiCall("saveCompany", c);
          setCompanies(prev => [...prev, c]);
        }}
        onUpdate={c => {
          apiCall("updateCompany", c);
          setCompanies(prev => prev.map(x => x.id === c.id ? c : x));
        }}
        onBack={() => go("splash")}
      />
    );
  }

  if (view === "profile") return (
    <ProfileScreen user={user} onClose={() => go("browse")}
      companies={allCompanies}
      onSignOut={() => { setUser(null); go("splash"); }} />
  );

  if (view === "browse") {
    if (activeCompany) return (
      <>
        <CompanyDetail company={activeCompany} onBack={() => setActiveCompany(null)}
          user={user}
          isFavourite={favourites.includes(activeCompany.id)}
          onToggleFavourite={() => setFavourites(prev => prev.includes(activeCompany.id) ? prev.filter(id=>id!==activeCompany.id) : [...prev, activeCompany.id])}
          onQuote={() => { if (!user) { go("signin"); } else { setQuoteFor(activeCompany); } }} />
        {quoteFor && (
          <QuoteModal company={quoteFor} userEmail={user?.email}
            onClose={() => setQuoteFor(null)}
            onSent={() => { setQuoteFor(null); }} />
        )}
      </>
    );
    return (
      <>
        <BrowseScreen
          userCoords={userCoords}
          searchRadius={searchRadius}
          onRadiusChange={setSearchRadius}
          companies={allCompanies}
          town={town}
          onChangeTown={() => go("location")}
          onBack={() => go("splash")}
          onCompany={c => { setActiveCompany(c); }}
          onSignIn={() => user ? go("profile") : go("signin")}
          user={user}
          initialCategory={browseCategory}
          onCategoryUsed={() => setBrowseCategory(null)}
        />
        {quoteFor && (
          <QuoteModal company={quoteFor} userEmail={user?.email}
            onClose={() => setQuoteFor(null)} onSent={() => setQuoteFor(null)} />
        )}
      </>
    );
  }

  if (view === "location") return (
    <LocationPicker
      onSelect={loc => { setTown(loc.town); setUserCoords({lat:loc.lat,lng:loc.lng}); setSearchRadius(loc.radius||10); go("browse"); }}
      onBack={() => go("splash")}
    />
  );

  if (view === "emergency-location") return (
    <LocationPicker
      onSelect={loc => { setTown(loc.town); setUserCoords({lat:loc.lat,lng:loc.lng}); setSearchRadius(loc.radius||10); go("emergency"); }}
      onBack={() => go("splash")}
      emergency
    />
  );

  if (view === "emergency") {
    const emergencyCompanies = allCompanies.filter(c => {
      if (c.status !== "approved" || !c.emergency || !c.featured) return false;
      if (!userCoords || searchRadius >= 150) return true;
      const cCoords = TOWN_COORDS[c.baseTown || c.town || (c.towns && c.towns[0])];
      if (!cCoords) return true;
      const companyReach = (c.coverageRadius || 20);
      const gap = distKm(userCoords.lat, userCoords.lng, cCoords.lat, cCoords.lng);
      return gap <= (searchRadius + companyReach);
    });
    return (
      <EmergencyScreen
        companies={emergencyCompanies}
        town={town}
        onBack={() => go("splash")}
      />
    );
  }

  if (view === "signin") return (
    <AuthScreen onAuthed={u => { setUser(u); go("browse"); }} onBack={() => go("browse")} />
  );

  // Splash
  if (town) return (
    <>
      {cookieBanner}
      <WelcomeBack town={town} user={user}
        onHelp={() => go("browse")}
        onEmergency={() => go("emergency-location")}
        onChangeTown={() => go("location")}
        onPortal={() => go("portal-auth")}
        onAdmin={() => go("admin-auth")}
        onContact={() => setOverlay("contact")}
        onAbout={() => setOverlay("about")}
        onSignIn={() => user ? go("profile") : go("signin")}
        onForBusiness={() => setOverlay("forbusiness")}
      />
    </>
  );

  return (
    <SplashScreen
      onHelp={() => go(town ? "browse" : "location")}
      onEmergency={() => go("emergency-location")}
      onPortal={() => go("portal-auth")}
      onAdmin={() => go("admin-auth")}
      onAbout={() => setOverlay("about")}
      onTerms={() => setOverlay("terms")}
      onPrivacy={() => setOverlay("privacy")}
      onContact={() => setOverlay("contact")}
      onDemoName={setDemoName}
    />
  );
}

const CSS = `@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600&family=Inter:wght@400;500;600;700;800&display=swap');

*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Inter',sans-serif;background:#FAF6EF;color:#1C1917;-webkit-font-smoothing:antialiased}
button{font-family:inherit;cursor:pointer}
input,textarea,select{font-family:inherit}
img{max-width:100%;display:block}

/* ── SCREEN ─── */
.screen{min-height:100vh;display:flex;flex-direction:column;background:#FAF6EF}

/* ── TOPBAR ─── */
.topbar{background:#1B3A4B;padding:12px 16px;position:sticky;top:0;z-index:50}
.topbar-light{background:#FAF6EF;border-bottom:1px solid #E4DCC8;}
.topbar-inner{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:44px}
.tb-back{background:rgba(255,255,255,0.12);border:none;border-radius:8px;width:34px;height:34px;display:flex;align-items:center;justify-content:center;color:#FAF6EF}
.topbar-light .tb-back{background:#F0EAD8;color:#1B3A4B}
.tb-brand{display:flex;align-items:center;gap:8px;flex:1;justify-content:center}
.tb-logo{height:28px;width:auto}
.tb-word{font-family:'Fraunces',serif;font-size:19px;font-weight:600;color:#FAF6EF;letter-spacing:-0.02em}
.topbar-light .tb-word{color:#1B3A4B}
.tb-mate{color:#C75D3A}
.topbar-light .tb-mate{color:#C75D3A}
.tb-title{font-size:16px;font-weight:700;color:#FAF6EF}
.topbar-light .tb-title{color:#1C1917}
.tb-right{display:flex;align-items:center;gap:8px}
.tb-account-btn{background:#F0EAD8;border:none;border-radius:20px;padding:6px 14px;font-size:13px;font-weight:700;color:#1B3A4B}
.tb-avatar{font-size:15px;font-weight:800;color:#1B3A4B}
.tb-signout{background:none;border:none;color:#9A9486;padding:4px}
.tb-gap{width:34px}

/* ── BUTTONS ─── */
.btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:none;border-radius:12px;padding:13px 20px;font-size:14px;font-weight:700;cursor:pointer;text-decoration:none;transition:opacity 0.15s}
.btn:active{opacity:0.85}
.btn:disabled{opacity:0.5;pointer-events:none}

.btn-secondary{background:#F5F0E8;color:#1B3A4B;border:1.5px solid #E4DCC8}
.btn-wa{background:#25D366;color:#fff}
.btn-full{width:100%}

/* ── FORMS ─── */
.field{margin-bottom:14px}
.field-label{display:block;font-size:13px;font-weight:700;color:#4A463E;margin-bottom:6px}
.field-sub{font-weight:400;color:#9A9486}
.input{width:100%;border:1.5px solid #E4DCC8;border-radius:10px;padding:11px 14px;font-size:14px;color:#1C1917;background:#fff;outline:none}
.input:focus{border-color:#1B3A4B}
.textarea{resize:vertical;min-height:80px}
select.input{appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%239A9486' stroke-width='1.5' fill='none'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 14px center;padding-right:36px}
.err{color:#C0392B;font-size:13px;margin:8px 0}

/* ── PHONE INPUT ─── */
.phone-wrap{position:relative;display:flex;border:1.5px solid #E4DCC8;border-radius:10px;background:#fff}
.phone-code-btn{border:none;border-right:1.5px solid #E4DCC8;background:#F5F0E8;padding:11px 12px;border-radius:10px 0 0 10px;font-size:14px;font-weight:600;color:#1C1917;white-space:nowrap}
.phone-num-input{flex:1;border:none;outline:none;background:none;padding:11px 12px;font-size:14px;color:#1C1917}
.phone-dropdown{position:absolute;top:calc(100% + 4px);left:0;right:0;background:#fff;border:1.5px solid #E4DCC8;border-radius:10px;z-index:200;max-height:220px;overflow-y:auto;box-shadow:0 4px 20px rgba(0,0,0,0.12)}
.phone-opt{display:flex;align-items:center;gap:10px;width:100%;background:none;border:none;border-bottom:1px solid #F0EAD8;padding:11px 14px;font-size:14px;color:#1C1917;cursor:pointer;text-align:left}
.phone-opt:last-child{border-bottom:none}
.phone-opt.active{background:#F5F0E8;font-weight:700}
.phone-opt span{margin-left:auto;color:#9A9486;font-size:13px}

/* ── SPLASH ─── */
.splash{min-height:100vh;display:flex;flex-direction:column;background:#FAF6EF}
.splash-hero{flex:1;background:#1B3A4B;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;padding:20px 24px 48px;position:relative;overflow:hidden;min-height:60vh}
.splash-orb{position:absolute;border-radius:50%;filter:blur(60px);pointer-events:none}
.splash-orb1{width:300px;height:300px;background:rgba(199,93,58,0.2);top:-80px;right:-60px}
.splash-orb2{width:250px;height:250px;background:rgba(245,200,66,0.08);bottom:-40px;left:-60px}
.splash-top{position:absolute;top:16px;left:20px;right:20px;display:flex;align-items:center;justify-content:space-between}
.splash-top .tb-word{color:#FAF6EF}
.splash-stamp{background:none;border:none;cursor:pointer;position:relative;width:200px;height:200px;display:flex;align-items:center;justify-content:center;z-index:1;margin-bottom:8px}
.stamp-ring{position:absolute;inset:0;width:100%;height:100%}
.stamp-inner{display:flex;flex-direction:column;align-items:center;gap:4px;z-index:1}
.stamp-name{font-family:'Fraunces',serif;font-size:22px;font-weight:600;color:#F5C842;letter-spacing:-0.01em}
.stamp-tag{font-size:8.5px;font-weight:800;letter-spacing:0.12em;color:#F5C842;text-transform:uppercase;margin-top:2px}
.splash-tagline{font-family:'Fraunces',serif;font-size:22px;font-style:italic;font-weight:400;color:rgba(245,200,66,0.85);margin-top:16px;letter-spacing:-0.01em;z-index:1}
.stamp-sub{font-size:7.5px;font-weight:600;letter-spacing:0.1em;color:rgba(245,200,66,0.5);text-transform:uppercase}
.splash-ctas{background:#FAF6EF;padding:24px 20px 44px;display:flex;flex-direction:column;gap:14px}
.cta-emergency{display:flex;align-items:center;gap:14px;background:#2D9B6F;border:none;border-radius:16px;padding:16px;cursor:pointer;text-align:left;box-shadow:0 3px 12px rgba(45,155,111,0.3)}
.cta-emergency .cta-icon{width:42px;height:42px;border-radius:12px;background:rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;color:#fff;flex-shrink:0}
.cta-emergency .cta-text{flex:1}
.cta-emergency .cta-text strong{display:block;font-size:15px;font-weight:700;color:#fff}
.cta-emergency .cta-text span{font-size:12px;color:rgba(255,255,255,0.7)}
.cta-emergency svg:last-child{color:rgba(255,255,255,0.5)}
.cta-main{background:#1B3A4B;border:none;border-radius:16px;padding:24px 20px;cursor:pointer;text-align:center;display:flex;flex-direction:column;gap:6px;box-shadow:0 4px 16px rgba(27,58,75,0.2)}
.cta-main strong{font-family:'Fraunces',serif;font-size:26px;font-weight:600;color:#FAF6EF}
.cta-main span{font-size:13px;color:rgba(255,255,255,0.6)}
.cta-portal{background:none;border:1.5px solid #E4DCC8;border-radius:12px;padding:12px;display:flex;align-items:center;justify-content:center;gap:8px;font-size:13.5px;font-weight:600;color:#6B6659}
.splash-footer{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;padding:8px 0}
.splash-footer button{background:none;border:none;font-size:12px;color:#9A9486;cursor:pointer;padding:2px}
.splash-footer span{color:#C8BC9C;font-size:12px}

/* ── WELCOME BACK ─── */
.wb{min-height:100vh;display:flex;flex-direction:column;background:#FAF6EF}
.wb-hero{flex:1;background:#1B3A4B;display:flex;flex-direction:column;padding:52px 24px 40px;position:relative;overflow:hidden;min-height:55vh}
.wb-orb{position:absolute;border-radius:50%;filter:blur(60px);pointer-events:none}
.wb-orb1{width:280px;height:280px;background:rgba(199,93,58,0.2);top:-80px;right:-60px}
.wb-orb2{width:200px;height:200px;background:rgba(42,96,112,0.3);bottom:20px;left:-60px}
.wb-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:auto;z-index:1}
.wb-town-pill{display:flex;align-items:center;gap:5px;background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.2);border-radius:20px;padding:6px 12px;font-size:12px;font-weight:600;color:rgba(255,255,255,0.8);cursor:pointer}
.wb-greeting{z-index:1;padding-top:32px}
.wb-hello{font-size:14px;color:rgba(255,255,255,0.6);margin-bottom:8px}
.wb-title{font-family:'Fraunces',serif;font-size:42px;font-weight:600;color:#FAF6EF;margin-bottom:8px;letter-spacing:-0.02em;line-height:1.1}
.wb-sub{font-size:15px;color:rgba(255,255,255,0.6);margin-bottom:20px}
.wb-tiles{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:12px}
.wb-tile{background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:6px}
.wb-tile-icon{width:64px;height:64px;border-radius:18px;display:flex;align-items:center;justify-content:center;border:1.5px solid rgba(255,255,255,0.15)}
.wb-tile span{font-size:11px;font-weight:700;color:#FAF6EF;text-align:center;line-height:1.2}
.wb-tagline{font-family:'Fraunces',serif;font-size:18px;font-style:italic;font-weight:400;color:rgba(245,200,66,0.85);margin-bottom:16px;letter-spacing:-0.01em}
.wb-footer{display:flex;align-items:center;justify-content:center;gap:8px;padding-top:4px}
.wb-footer button{background:none;border:none;font-size:12px;color:#9A9486;cursor:pointer;padding:2px}
.wb-footer span{color:#C8BC9C;font-size:12px}
.wb-see-all{background:none;border:none;font-size:12px;font-weight:600;color:#F5C842;cursor:pointer;padding:0}
.wb-actions{padding:16px 20px 40px;display:flex;flex-direction:column;gap:12px;background:#FAF6EF}

/* ── LOCATION ─── */

.use-location-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;background:#1B3A4B;border:none;border-radius:12px;padding:14px;font-size:14px;font-weight:700;color:#FAF6EF;margin-bottom:16px}
.use-location-btn svg{color:#F5C842}
.location-or{font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:#9A9486;text-align:center;margin-bottom:14px}
.town-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
.town-btn{padding:16px 8px;background:#fff;border:1.5px solid #E4DCC8;border-radius:12px;font-size:13px;font-weight:600;color:#1C1917;cursor:pointer}
.town-btn-sel{background:#1B3A4B;border-color:#1B3A4B;color:#FAF6EF}

/* ── BROWSE ─── */
.browse-screen{background:#fff}
.town-bar{border-bottom:1px solid #F0EAD8;background:#fff}

.town-chips::-webkit-scrollbar{display:none}
.chip{flex-shrink:0;background:#fff;border:1.5px solid #E4DCC8;border-radius:20px;padding:6px 14px;font-size:13px;font-weight:600;color:#4A463E;white-space:nowrap}
.chip-on{background:#1B3A4B;border-color:#1B3A4B;color:#fff}
.search-bar{display:flex;align-items:center;gap:10px;background:#F5F0E8;border-radius:12px;padding:11px 14px;margin:12px 16px;border-bottom:0}
.search-icon{color:#9A9486;flex-shrink:0}
.search-input{flex:1;background:none;border:none;outline:none;font-size:15px;color:#1C1917}
.search-input::placeholder{color:#C8BC9C}
.search-clear{background:none;border:none;color:#9A9486;display:flex}
.cat-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;padding:16px}
.cat-tile{background:#fff;border:none;border-radius:14px;overflow:hidden;box-shadow:0 1px 6px rgba(0,0,0,0.07);cursor:pointer;display:flex;flex-direction:column;text-align:left;width:100%}
.cat-tile-top{height:110px;display:flex;align-items:center;justify-content:center;width:100%}
.cat-tile-emoji{font-size:36px;line-height:1}
.cat-tile span{font-size:13px;font-weight:700;color:#1C1917;padding:10px 14px 14px;display:block}
.results-area{padding-bottom:40px}
.results-header{display:flex;align-items:center;gap:12px;padding:12px 16px;border-bottom:1px solid #F0EAD8}
.results-back{display:flex;align-items:center;gap:4px;background:none;border:none;font-size:13px;font-weight:600;color:#9A9486;cursor:pointer}
.results-header span:nth-child(2){flex:1;font-size:14px;font-weight:700;color:#1C1917}
.results-count{font-size:12px;color:#9A9486}
.company-list{padding:12px 16px;display:flex;flex-direction:column;gap:12px}
.company-card{display:flex;gap:12px;background:#fff;border:1.5px solid #F0EAD8;border-radius:14px;padding:12px;cursor:pointer;text-align:left;width:100%}
.company-card-featured{border-color:#C75D3A;background:#FFFAF7;box-shadow:0 2px 12px rgba(199,93,58,0.12)}
.cc-response{font-size:11px;color:#2D9B6F;font-weight:600;margin:2px 0 0}
.detail-response{font-size:12px;font-weight:600;color:#2D9B6F;margin-top:4px}
.detail-verified{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:600;color:#2D9B6F;background:#F0FDF4;border-radius:20px;padding:4px 12px;margin-top:6px;width:fit-content}
.detail-featured{font-size:12px;font-weight:700;color:#C75D3A;background:#FFF8F5;border-radius:20px;padding:4px 12px;margin-top:4px;width:fit-content}
.cc-verified{font-size:11px;font-weight:700;color:#2D9B6F;background:#F0FDF4;border-radius:20px;padding:2px 8px;margin-left:4px}
.cc-photo{width:72px;height:72px;border-radius:10px;overflow:hidden;flex-shrink:0;background:#F5F0E8;position:relative}
.cc-photo img{width:100%;height:100%;object-fit:cover}
.cc-photo-placeholder{width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#C8BC9C}
.cc-badge{position:absolute;top:4px;left:4px;font-size:9px;font-weight:800;padding:2px 6px;border-radius:6px}
.cc-badge-em{background:#C0392B;color:#fff}
.cc-badge-sp{background:#1B3A4B;color:#FAF6EF}
.cc-info{flex:1;min-width:0}
.cc-top{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:2px}
.cc-name{font-size:14px;font-weight:700;color:#1C1917}
.cc-rating{display:flex;align-items:center;gap:3px;font-size:12px;font-weight:700;color:#1C1917;flex-shrink:0}
.cc-cat{font-size:12px;color:#9A9486;margin-bottom:4px}
.cc-distance{font-size:11px;color:#2D9B6F;font-weight:600;display:flex;align-items:center;gap:3px}
.cc-blurb{font-size:13px;color:#6B6659;line-height:1.4;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
.cc-price{font-size:12px;font-weight:700;color:#C75D3A;margin-top:4px}

/* ── COMPANY DETAIL ─── */
.detail-body{flex:1;padding-bottom:40px}
.detail-photo{width:100%;height:220px;object-fit:cover}
.detail-section{padding:20px 20px 0}
.detail-top{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:4px}
.detail-name{font-family:'Fraunces',serif;font-size:24px;font-weight:600;color:#1C1917}
.detail-rating{display:flex;align-items:center;gap:4px;font-size:14px;font-weight:700;color:#1C1917}
.detail-cat{font-size:13px;color:#9A9486;margin-bottom:10px}
.detail-blurb{font-size:15px;color:#6B6659;line-height:1.6}
.detail-actions{padding:16px 20px;display:flex;flex-direction:column;gap:10px}
.detail-section-title{font-size:13px;font-weight:800;text-transform:uppercase;letter-spacing:0.08em;color:#9A9486;margin-bottom:10px}
.detail-services{display:flex;flex-wrap:wrap;gap:8px}
.service-tag{background:#F5F0E8;border-radius:8px;padding:5px 10px;font-size:12.5px;font-weight:600;color:#4A463E}

/* ── MODALS ─── */
.modal-bg{position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:300;display:flex;align-items:flex-end}
.modal{background:#FAF6EF;border-radius:20px 20px 0 0;width:100%;max-height:90vh;overflow-y:auto;padding-bottom:32px}
.modal-head{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #F0EAD8}
.modal-head h3{font-family:'Fraunces',serif;font-size:18px;font-weight:600;color:#1C1917}
.modal-close{background:none;border:none;color:#9A9486;display:flex}
.modal-body{padding:20px}
.sent-state{padding:32px 20px;display:flex;flex-direction:column;align-items:center;gap:12px;text-align:center}
.sent-state p{font-size:15px;color:#6B6659;line-height:1.5}

/* ── AUTH ─── */
.auth-screen{min-height:100vh;padding:60px 24px 40px;background:#FAF6EF;display:flex;flex-direction:column;gap:0}
.auth-back-btn{display:flex;align-items:center;gap:6px;background:none;border:none;font-size:13px;font-weight:600;color:#9A9486;margin-bottom:24px;cursor:pointer}
.auth-logo{display:flex;align-items:center;gap:8px;margin-bottom:32px}
.auth-wordmark{font-family:'Fraunces',serif;font-size:22px;font-weight:600;color:#1B3A4B;letter-spacing:-0.02em}
.auth-title{font-family:'Fraunces',serif;font-size:28px;font-weight:600;color:#1C1917;margin-bottom:24px;letter-spacing:-0.02em}
.auth-switch{font-size:13px;color:#9A9486;text-align:center;margin-top:16px}
.auth-switch button{background:none;border:none;color:#C75D3A;font-weight:700;font-size:13px;cursor:pointer}

/* ── PORTAL ─── */
.portal-body{padding:20px;flex:1;display:flex;flex-direction:column;gap:0}
.portal-empty{display:flex;flex-direction:column;align-items:center;text-align:center;padding:40px 0;gap:14px}
.portal-empty h3{font-family:'Fraunces',serif;font-size:22px;font-weight:600;color:#1C1917}
.portal-empty p{font-size:15px;color:#6B6659;line-height:1.5;max-width:280px}
.portal-listing{display:flex;flex-direction:column;gap:16px}
.portal-listing-head{display:flex;align-items:center;justify-content:space-between;gap:8px}
.portal-listing-head h3{font-family:'Fraunces',serif;font-size:20px;font-weight:600;color:#1C1917}
.portal-listing-cat{font-size:13px;color:#9A9486}
.portal-note{font-size:13px;color:#6B6659;line-height:1.5;background:#F5F0E8;border-radius:10px;padding:12px 14px}
.status-badge{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;padding:4px 10px;border-radius:20px}

.success-banner{display:flex;align-items:center;gap:8px;background:#D1FAE5;border-radius:10px;padding:12px 14px;font-size:13px;font-weight:600;color:#065F46;margin-bottom:16px}
.form-steps{display:flex;flex-direction:column;gap:0}
.form-title{font-family:'Fraunces',serif;font-size:22px;font-weight:600;color:#1C1917;margin-bottom:6px}
.form-sub{font-size:14px;color:#9A9486;margin-bottom:20px}
.form-back{display:flex;align-items:center;gap:6px;background:none;border:none;font-size:13px;font-weight:600;color:#9A9486;margin-bottom:20px;cursor:pointer}
.check-label{display:flex;align-items:center;gap:10px;font-size:14px;color:#4A463E;margin-bottom:16px;cursor:pointer}
.check-label input{width:18px;height:18px;accent-color:#1B3A4B}

.coverage-btn-wide

/* ── RADIUS PICKER ─── */
.radius-body{padding:20px;display:flex;flex-direction:column;gap:16px}
.radius-found-row{display:flex;align-items:center;gap:8px;background:#E8F5EF;border-radius:10px;padding:12px 14px;font-size:14px;color:#1C1917}
.radius-found-row strong{color:#1B3A4B}
.radius-title{font-family:'Fraunces',serif;font-size:22px;font-weight:600;color:#1C1917;margin:0}
.radius-sub{font-size:14px;color:#9A9486;margin:0;line-height:1.5}
.radius-options{display:flex;flex-direction:column;gap:8px}
.radius-btn{display:flex;align-items:center;justify-content:space-between;background:#fff;border:1.5px solid #E4DCC8;border-radius:12px;padding:14px 16px;cursor:pointer;text-align:left}
.radius-btn-on{background:#1B3A4B;border-color:#1B3A4B}
.radius-km{font-size:15px;font-weight:700;color:#1C1917}
.radius-btn-on .radius-km{color:#FAF6EF}
.radius-desc{font-size:13px;color:#9A9486}
.radius-btn-on .radius-desc{color:rgba(255,255,255,0.6)}
.radius-manual-link{background:none;border:none;font-size:13px;color:#9A9486;cursor:pointer;text-align:center;padding:8px}
/* ── PRICING ─── */
.portal-pricing{padding-top:8px}
.portal-pricing h4{font-size:14px;font-weight:800;text-transform:uppercase;letter-spacing:0.08em;color:#9A9486;margin-bottom:12px}
.pricing-cards{display:flex;flex-direction:column;gap:12px}
.pricing-card{border:1.5px solid #E4DCC8;border-radius:14px;padding:18px;background:#fff;position:relative}
.pricing-card-featured{border-color:#C75D3A;background:#FFF8F5}
.pricing-badge{position:absolute;top:-10px;left:16px;background:#C75D3A;color:#fff;font-size:10px;font-weight:700;padding:2px 10px;border-radius:20px}
.pricing-name{display:block;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#9A9486;margin-bottom:6px}
.pricing-price{display:block;font-family:'Fraunces',serif;font-size:32px;font-weight:600;color:#1C1917;margin-bottom:12px}
.pricing-price small{font-size:14px;color:#9A9486;font-family:'Inter',sans-serif;font-weight:400}
.pricing-features{list-style:none;display:flex;flex-direction:column;gap:7px;margin-bottom:14px}
.pricing-features li{display:flex;align-items:center;gap:8px;font-size:13px;color:#4A463E}
.pricing-features svg{color:#2D9B6F;flex-shrink:0}

.map-view{display:flex;flex-direction:column;gap:8px;padding:8px 0}
.map-hint{font-size:12px;color:#9A9486;text-align:center;margin-bottom:4px}
.map-company-row{display:flex;align-items:center;gap:12px;background:#fff;border:1.5px solid #F0EAD8;border-radius:12px;padding:12px;text-decoration:none;color:inherit}
.map-pin{font-size:20px;flex-shrink:0}
.map-company-info{display:flex;flex-direction:column;flex:1}
.map-company-info strong{font-size:14px;color:#1C1917}
.map-company-info span{font-size:12px;color:#9A9486}

/* ── FOR BUSINESS ─── */
.fb-hero{display:flex;flex-direction:column;align-items:center;text-align:center;gap:12px;padding:24px 0 20px}
.fb-title{font-family:'Fraunces',serif;font-size:22px;font-weight:600;color:#1C1917;line-height:1.3}
.fb-sub{font-size:14px;color:#6B6659;line-height:1.6}
.fb-section{margin-bottom:28px}
.fb-section-title{font-family:'Fraunces',serif;font-size:18px;font-weight:600;color:#1C1917;margin-bottom:14px}
.fb-step{display:flex;gap:14px;align-items:flex-start;margin-bottom:14px}
.fb-step-num{background:#1B3A4B;color:#fff;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;flex-shrink:0;margin-top:2px}
.fb-step strong{font-size:14px;color:#1C1917;display:block;margin-bottom:2px}
.fb-step p{font-size:13px;color:#6B6659;line-height:1.5;margin:0}
.fb-plan{border:1.5px solid #E4DCC8;border-radius:14px;padding:18px;margin-bottom:12px;background:#fff}
.fb-plan-featured{border-color:#C75D3A;background:#FFF8F5;position:relative}
.fb-plan-badge{position:absolute;top:-10px;left:16px;background:#C75D3A;color:#fff;font-size:11px;font-weight:700;padding:2px 10px;border-radius:20px}
.fb-plan-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px}
.fb-plan-name{font-weight:700;font-size:16px;color:#1C1917}
.fb-plan-price{font-weight:800;font-size:22px;color:#1B3A4B;font-family:'Fraunces',serif}
.fb-plan-features{list-style:none;display:flex;flex-direction:column;gap:6px}
.fb-plan-features li{font-size:13px;color:#4B5563}
.fb-why{display:flex;gap:12px;align-items:flex-start;margin-bottom:12px}
.fb-why p{font-size:13px;color:#4B5563;line-height:1.5;margin:0;padding-top:2px}

/* ── VERIFF ─── */
.veriff-screen{display:flex;flex-direction:column;align-items:center;gap:16px;padding:24px 0;text-align:center}
.veriff-badge{background:#F0FDF4;border:1.5px solid #86EFAC;border-radius:10px;padding:10px 16px;font-size:13px;color:#166534;font-weight:600}

/* ── REFERRALS ─── */
.referral-banner{background:linear-gradient(135deg,#1B3A4B,#2D5A6B);border-radius:14px;padding:16px;color:#fff;margin-bottom:16px}
.referral-banner-top{display:flex;gap:12px;align-items:flex-start;margin-bottom:12px}
.referral-emoji{font-size:28px;flex-shrink:0}
.referral-banner-top strong{font-size:15px;display:block;margin-bottom:4px}
.referral-banner-top p{font-size:13px;opacity:0.85;line-height:1.4;margin:0}
.referral-progress{margin-bottom:8px}
.referral-progress-bar{background:rgba(255,255,255,0.2);border-radius:20px;height:8px;margin-bottom:6px;overflow:hidden}
.referral-progress-fill{background:#F5C842;height:100%;border-radius:20px;transition:width 0.3s}
.referral-progress-text{font-size:12px;opacity:0.9}
.referral-total{font-size:11px;opacity:0.7;margin-top:4px}
.referral-link-box{background:#F9F6F0;border-radius:12px;padding:14px;margin-bottom:16px}

/* ── RECOMMENDATIONS ─── */
.rec-card{display:flex;align-items:center;gap:10px;padding:10px;background:#F9F6F0;border-radius:10px;margin-bottom:8px}
.rec-card strong{font-size:13px;color:#1C1917;display:block}
.rec-card span{font-size:12px;color:#9A9486}

/* ── COMPANY DASHBOARD ─── */
.cd-header{background:#1B3A4B;padding:0 0 16px;position:relative}
.cd-cover{width:100%;height:140px;object-fit:cover;display:block;opacity:0.6}
.cd-cover-placeholder{width:100%;height:100px;background:rgba(255,255,255,0.1);display:flex;align-items:center;justify-content:center}
.cd-header-info{padding:12px 16px 0;position:relative}
.cd-company-name{font-family:'Fraunces',serif;font-size:20px;font-weight:700;color:#fff;margin:0}
.company-detail-row{display:flex;justify-content:space-between;align-items:flex-start;padding:10px 0;border-bottom:1px solid #F0EAD8;font-size:14px}
.detail-label{font-weight:600;color:#9A9486;font-size:12px;text-transform:uppercase;letter-spacing:0.05em;padding-top:2px}
.job-card{background:#fff;border:1.5px solid #F0EAD8;border-radius:14px;padding:14px 16px;margin-bottom:10px;display:flex;flex-direction:column;gap:8px}
.job-card.job-complete{opacity:0.6;border-color:#D1FAE5;background:#F0FDF4}
.job-card-head{display:flex;justify-content:space-between;align-items:center}
.job-card-head strong{font-size:15px;color:#1C1917}
.job-date{font-size:12px;color:#9A9486}
.job-msg{font-size:13px;color:#4B5563;line-height:1.5;margin:0}
.job-reply{font-size:13px;color:#C75D3A;font-weight:600;text-decoration:none}
.job-card-foot{display:flex;justify-content:space-between;align-items:center;margin-top:4px}
.job-complete-btn{background:#1B3A4B;color:#fff;border:none;border-radius:20px;padding:5px 14px;font-size:12px;font-weight:700;cursor:pointer}
.job-done{font-size:12px;color:#2D9B6F;font-weight:600}
.job-status-badge{font-size:11px;font-weight:700;padding:2px 10px;border-radius:20px;background:#F0EAD8;color:#6B6659}
.job-complete .job-status-badge{background:#D1FAE5;color:#065F46}

.activity-note-box{display:flex;flex-direction:column;gap:8px;margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid #F0EAD8}
.activity-item{display:flex;justify-content:space-between;align-items:flex-start;gap:8px;padding:10px 0;border-bottom:1px solid #F9F6F0}
.activity-text{font-size:13px;color:#1C1917;line-height:1.4;flex:1}
.activity-date{font-size:11px;color:#9A9486;flex-shrink:0;white-space:nowrap}

/* ── ADMIN ─── */
.admin-stats-row{display:flex;gap:8px;padding:12px 16px;background:#F9F6F0;border-bottom:1px solid #F0EAD8}
.admin-stat{flex:1;display:flex;flex-direction:column;align-items:center;gap:2px}
.admin-stat-num{font-family:'Fraunces',serif;font-size:22px;font-weight:700;color:#1B3A4B}
.admin-stat-label{font-size:11px;color:#9A9486;text-transform:uppercase;letter-spacing:0.05em}
.admin-tabs{display:flex;border-bottom:1px solid #F0EAD8;background:#fff}
.admin-tab{flex:1;padding:12px 8px;background:none;border:none;border-bottom:2px solid transparent;font-size:13px;font-weight:600;color:#9A9486;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px}
.admin-tab-on{color:#1B3A4B;border-bottom-color:#C75D3A}
.tab-count{background:#F0EAD8;border-radius:20px;padding:1px 7px;font-size:11px;font-weight:700;color:#6B6659}
.admin-list{padding:12px 16px;display:flex;flex-direction:column;gap:12px}
.admin-card{background:#fff;border:1.5px solid #F0EAD8;border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:12px}
.admin-card-info{display:flex;flex-direction:column;gap:3px}
.admin-card-info strong{font-size:15px;font-weight:700;color:#1C1917}
.admin-card-info span{font-size:12px;color:#9A9486}
.admin-blurb{font-size:13px;color:#6B6659;margin-top:4px}
.admin-card-actions{display:flex;gap:8px}

/* ── PROFILE ─── */
.profile-hero{display:flex;align-items:center;gap:14px;padding:20px;background:#1B3A4B}
.profile-avatar{width:50px;height:50px;border-radius:50%;background:#C75D3A;color:#FAF6EF;display:flex;align-items:center;justify-content:center;font-size:20px;font-weight:700;font-family:'Fraunces',serif;flex-shrink:0}
.profile-name{font-size:18px;font-weight:700;color:#FAF6EF;margin-bottom:2px;font-family:'Fraunces',serif}
.profile-email{font-size:12px;color:rgba(255,255,255,0.55)}
.profile-tabs{display:flex;border-bottom:1px solid #F0EAD8;background:#fff}
.profile-tab{flex:1;padding:12px 8px;background:none;border:none;border-bottom:2px solid transparent;font-size:13px;font-weight:600;color:#9A9486;cursor:pointer}
.profile-tab-on{color:#1B3A4B;border-bottom-color:#C75D3A}

/* ── HISTORY ─── */
.history-row{display:flex;align-items:center;gap:12px;padding:13px 0;border-bottom:1px solid #F0EAD8}
.history-info{flex:1}
.history-info strong{display:block;font-size:14px;color:#1C1917}
.history-info span{font-size:12px;color:#9A9486}
.history-date{font-size:11px;color:#9A9486;flex-shrink:0}

/* ── ABOUT ─── */
.about-body{padding:24px 20px 40px;flex:1}
.about-hero{background:#1B3A4B;margin:-24px -20px 24px;padding:32px 20px;border-radius:0 0 20px 20px}
.about-headline{font-family:'Fraunces',serif;font-size:24px;font-weight:600;color:#FAF6EF;margin-bottom:10px;line-height:1.2}

.about-steps{display:flex;flex-direction:column;gap:20px;margin-bottom:24px}
.about-step{display:flex;align-items:flex-start;gap:14px}

.about-step strong{display:block;font-size:15px;font-weight:700;color:#1C1917;margin-bottom:3px}
.about-step p{font-size:13px;color:#6B6659;line-height:1.5}
.about-towns{background:#F5F0E8;border-radius:12px;padding:16px;margin-bottom:24px}
.about-towns-label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:#9A9486;margin-bottom:6px}

.about-footer{font-size:12px;color:#9A9486;line-height:1.8}

/* ── ABOUT PAGE ─── */

.about-hero{background:#1B3A4B;padding:28px 20px 32px}
.about-logo-row{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.about-logo{height:40px;width:auto}

.about-headline{font-family:'Fraunces',serif;font-size:24px;font-weight:600;color:#FAF6EF;line-height:1.2;margin-bottom:12px;letter-spacing:-0.01em}

.about-section{padding:24px 20px;border-bottom:1px solid #F0EAD8}

.about-how-text strong{display:block;font-size:15px;font-weight:700;color:#1C1917;margin-bottom:4px}
.about-how-text p{font-size:13px;color:#6B6659;line-height:1.5}

.about-trust-card strong{font-size:13px;font-weight:700;color:#FAF6EF}
.about-trust-card p{font-size:12px;color:rgba(255,255,255,0.55);line-height:1.5}

.about-cat span:first-child{font-size:24px}
.about-footer{padding:24px 20px;text-align:center;background:#F5F0E8}

.about-footer p{font-size:12px;color:#9A9486;line-height:1.8}
.about-spanish{font-style:italic;color:#C8BC9C !important}
/* ── LEGAL ─── */
.legal-body{padding:20px 20px 40px;flex:1}
.legal-updated{font-size:12px;color:#9A9486;margin-bottom:20px}
.legal-section{margin-bottom:20px}
.legal-section h3{font-size:14px;font-weight:700;color:#1C1917;margin-bottom:6px}
.legal-section p{font-size:13.5px;color:#6B6659;line-height:1.6}

/* ── LEGAL PAGES ─── */
.legal-body{flex:1;padding:0 0 48px;overflow-y:auto}
.legal-header{background:#1B3A4B;padding:24px 20px;margin-bottom:8px}
.legal-updated{font-size:12px;color:rgba(255,255,255,0.5);margin-bottom:4px}
.legal-operator{font-size:13px;color:rgba(255,255,255,0.7);line-height:1.6}
.legal-operator strong{color:#FAF6EF}
.legal-notice{display:flex;align-items:flex-start;gap:10px;background:rgba(45,155,111,0.2);border-radius:10px;padding:12px;margin-top:14px}
.legal-notice p{font-size:13px;color:rgba(255,255,255,0.85);line-height:1.5;font-weight:600}
.legal-section{padding:16px 20px;border-bottom:1px solid #F0EAD8}
.legal-section h3{font-size:14px;font-weight:800;color:#1B3A4B;margin-bottom:8px;letter-spacing:-0.01em}
.legal-section p{font-size:13.5px;color:#4A463E;line-height:1.7}
.legal-footer{padding:20px;text-align:center;font-size:12px;color:#9A9486;line-height:2}
/* ── EMPTY ─── */
.empty{padding:40px 20px;text-align:center;display:flex;flex-direction:column;align-items:center;gap:10px}
.empty-title{font-family:'Fraunces',serif;font-size:20px;font-weight:600;color:#1C1917}
.empty-sub{font-size:14px;color:#9A9486;line-height:1.5}

.about-trust{display:flex;flex-direction:column;gap:12px;margin-bottom:24px}
.about-trust-item{display:flex;align-items:center;gap:12px;background:#fff;border-radius:12px;padding:14px;border:1px solid #F0EAD8;font-size:14px;font-weight:600;color:#1C1917}
.about-spanish{margin-top:8px;font-style:italic;color:#C8BC9C;font-size:12px}
/* ── EMERGENCY SCREEN ─── */
.em-screen{background:#FAF6EF}
.em-topbar{background:#2D9B6F;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;min-height:44px}
.em-topbar-title{font-size:16px;font-weight:700;color:#fff}
.em-body{flex:1;padding-bottom:80px}
.em-hero{background:#2D9B6F;padding:28px 24px 32px;text-align:center;display:flex;flex-direction:column;align-items:center;gap:12px}
.em-title{font-family:'Fraunces',serif;font-size:28px;font-weight:600;color:#fff}
.em-sub{font-size:14px;color:rgba(255,255,255,0.8);line-height:1.5;max-width:300px}
.em-form{padding:20px}
.em-companies-preview{background:#FEE2E2;border-radius:12px;padding:14px;margin-bottom:16px}
.em-companies-label{font-size:12px;font-weight:700;color:#991B1B;margin-bottom:8px;text-transform:uppercase;letter-spacing:0.06em}
.em-company-row{display:flex;align-items:center;gap:8px;font-size:13px;color:#1C1917;padding:4px 0}
.em-blast-btn{width:100%;background:#2D9B6F;border:none;border-radius:14px;padding:16px;display:flex;align-items:center;justify-content:center;gap:10px;font-size:15px;font-weight:700;color:#fff;cursor:pointer;box-shadow:0 4px 16px rgba(45,155,111,0.35)}
.em-blast-btn:disabled{opacity:0.5;pointer-events:none}
.em-disclaimer{font-size:12px;color:#9A9486;text-align:center;margin-top:10px;line-height:1.5}
.em-no-companies{padding:32px 24px;text-align:center;display:flex;flex-direction:column;gap:12px;align-items:center}
.em-no-companies p{font-size:15px;color:#6B6659;line-height:1.5}
.em-success{padding:48px 24px;display:flex;flex-direction:column;align-items:center;gap:16px;text-align:center}
.em-success h2{font-family:'Fraunces',serif;font-size:26px;font-weight:600;color:#1C1917}
.em-success p{font-size:15px;color:#6B6659;line-height:1.5;max-width:300px}
.em-reminder{font-size:13px;font-weight:600;color:#2D9B6F}
.em-cat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding:20px}
.em-cat-btn{display:flex;flex-direction:column;align-items:center;gap:8px;background:#fff;border:1.5px solid #E4DCC8;border-radius:14px;padding:18px 8px;cursor:pointer}
.em-cat-btn:active{background:#FEE2E2;border-color:#C0392B}
.em-cat-icon{font-size:28px}
.em-cat-btn span:last-child{font-size:12px;font-weight:700;color:#1C1917;text-align:center}
.em-112{position:fixed;bottom:0;left:0;right:0;background:#1C1917;padding:14px 20px;display:flex;align-items:center;justify-content:space-between}
.em-112 span{font-size:13px;color:rgba(255,255,255,0.6)}
.em-112-link{font-size:15px;font-weight:800;color:#fff;text-decoration:none;background:#C0392B;padding:8px 18px;border-radius:20px}
/* ── ABOUT PAGE ─── */
.about-body{flex:1;padding-bottom:48px;overflow-y:auto}
.about-hero{background:#1B3A4B;padding:28px 20px 32px;position:relative;overflow:hidden}
.about-logo-row{display:flex;align-items:center;gap:10px;margin-bottom:16px}
.about-headline{font-family:'Fraunces',serif;font-size:26px;font-weight:600;color:#FAF6EF;line-height:1.2;margin-bottom:8px;letter-spacing:-0.02em}
.about-tagline-text{font-family:'Fraunces',serif;font-size:17px;font-style:italic;color:rgba(245,200,66,0.9)}
.about-card{background:#fff;margin:16px;border-radius:14px;padding:18px;border:1px solid #F0EAD8}
.about-card-text{font-size:14px;color:#6B6659;line-height:1.7}
.about-section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.12em;color:#9A9486;padding:20px 20px 10px}
.about-steps{padding:0 16px;display:flex;flex-direction:column;gap:16px}
.about-step{display:flex;align-items:flex-start;gap:14px;background:#fff;border-radius:14px;padding:16px;border:1px solid #F0EAD8}
.about-step-num{width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:#fff;flex-shrink:0;margin-top:2px}
.about-step-content strong{display:block;font-size:14px;font-weight:700;color:#1C1917;margin-bottom:4px}
.about-step-content p{font-size:13px;color:#6B6659;line-height:1.5}
.about-em-card{background:#C0392B;border-radius:14px;margin:16px;padding:18px}
.about-em-head{display:flex;align-items:center;gap:8px;margin-bottom:10px}
.about-em-head strong{font-size:15px;font-weight:700;color:#fff}
.about-em-card p{font-size:13px;color:rgba(255,255,255,0.85);line-height:1.6}
.about-trust{padding:0 16px;display:flex;flex-direction:column;gap:12px}
.about-trust-item{display:flex;align-items:flex-start;gap:14px;background:#fff;border-radius:14px;padding:16px;border:1px solid #F0EAD8}
.about-trust-item svg{flex-shrink:0;margin-top:2px}
.about-trust-item strong{display:block;font-size:14px;font-weight:700;color:#1C1917;margin-bottom:3px}
.about-trust-item p{font-size:13px;color:#6B6659;line-height:1.5}
.about-towns{margin:16px;background:#F5F0E8;border-radius:14px;padding:18px}
.about-towns-label{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:#9A9486;margin-bottom:12px}
.about-towns-grid{display:flex;flex-wrap:wrap;gap:8px}
.about-town-pill-more{background:#F5F0E8;border-color:#C8BC9C;color:#9A9486;font-style:italic}
.about-town-pill{display:flex;align-items:center;gap:4px;background:#fff;border:1px solid #E4DCC8;border-radius:20px;padding:5px 10px;font-size:12px;font-weight:600;color:#1C1917}
.about-footer{margin:0 16px;padding-top:20px;border-top:1px solid #E4DCC8;font-size:12px;color:#9A9486;line-height:2;text-align:center}
.about-footer strong{color:#1C1917}
.about-spanish{font-style:italic;color:#C8BC9C;margin-top:4px}
/* ── COOKIE BANNER ─── */
.cookie-banner{position:fixed;bottom:0;left:0;right:0;z-index:500;background:#1B3A4B;padding:16px 20px 32px}
.cookie-text{font-size:13px;color:rgba(255,255,255,0.8);line-height:1.5;margin-bottom:12px}
.cookie-link{background:none;border:none;color:#F5C842;font-size:13px;font-weight:600;cursor:pointer;padding:0}
.cookie-btns{display:flex;gap:10px}
.cookie-ess{flex:1;background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.2);border-radius:10px;padding:10px;font-size:13px;font-weight:600;color:#FAF6EF;cursor:pointer}
.cookie-acc{flex:1;background:#C75D3A;border:none;border-radius:10px;padding:10px;font-size:13px;font-weight:700;color:#fff;cursor:pointer}

/* ── LOCATION FLOW ─── */
.loc-screen{background:#FAF6EF;display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh}
.loc-back{position:absolute;top:52px;left:16px;background:#F0EAD8;border:none;border-radius:8px;width:34px;height:34px;display:flex;align-items:center;justify-content:center;color:#1B3A4B;cursor:pointer}
.loc-body{display:flex;flex-direction:column;align-items:center;text-align:center;padding:40px 32px;gap:16px}
.loc-icon{width:80px;height:80px;background:#FAF6EF;border-radius:50%;display:flex;align-items:center;justify-content:center;border:2px solid #E4DCC8}
.loc-icon-spin svg{animation:spin 1.5s linear infinite}
@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
.loc-title{font-family:'Fraunces',serif;font-size:24px;font-weight:600;color:#1C1917;margin:0}
.loc-sub{font-size:14px;color:#9A9486;line-height:1.5;margin:0;max-width:260px}
.loc-manual-body{padding:20px;flex:1}
.loc-denied-banner{display:flex;align-items:center;gap:8px;background:#FEF3CD;border-radius:10px;padding:12px 14px;font-size:13px;color:#856404;font-weight:600;margin-bottom:16px}
.town-btn-other{border-style:dashed;color:#9A9486}
/* ── LOCATION PILL ─── */
.loc-pill-row{display:flex;align-items:center;gap:8px;padding:10px 16px;background:#fff}
.loc-pill-text{flex:1;font-size:14px;font-weight:700;color:#1C1917}
.loc-pill-change{background:none;border:none;font-size:13px;font-weight:600;color:#C75D3A;cursor:pointer;padding:0}
/* ── FILTER BAR ─── */
.filter-bar{display:flex;gap:8px;padding:10px 16px;border-bottom:1px solid #F0EAD8;overflow-x:auto;scrollbar-width:none}
.filter-bar::-webkit-scrollbar{display:none}
.filter-chip{flex-shrink:0;background:#fff;border:1.5px solid #E4DCC8;border-radius:20px;padding:6px 14px;font-size:13px;font-weight:600;color:#4A463E;cursor:pointer;white-space:nowrap}
.filter-chip-on{background:#1B3A4B;border-color:#1B3A4B;color:#fff}
.demo-bar{background:#F5F0E8;border-top:1px solid #E4DCC8;padding:14px 20px;display:flex;align-items:center;gap:10px}
.demo-label{font-size:12px;font-weight:700;color:#9A9486;white-space:nowrap}
.demo-input{flex:1;border:1.5px solid #E4DCC8;border-radius:8px;padding:8px 12px;font-size:13px;color:#1C1917;background:#fff;outline:none}
.email-status{font-size:12px;font-weight:600;color:#1B3A4B;text-align:center;padding:8px 16px;background:#F5F0E8;border-radius:8px;margin:0 20px}
.portal-empty-icon{width:72px;height:72px;background:#F5F0E8;border-radius:20px;display:flex;align-items:center;justify-content:center}
.portal-empty-features{display:flex;flex-direction:column;gap:8px;width:100%;text-align:left;background:#F5F0E8;border-radius:12px;padding:16px}
.portal-empty-feature{font-size:14px;font-weight:600;color:#1C1917}
.portal-cta-btn{width:100%;background:#1B3A4B;border:none;border-radius:14px;padding:18px;font-size:17px;font-weight:700;color:#FAF6EF;cursor:pointer;font-family:'Fraunces',serif;letter-spacing:-0.01em}
.portal-cta-btn:active{opacity:0.9}
.portal-empty-sub{font-size:12px;color:#9A9486;margin-top:4px}
.photo-upload-label{display:block;cursor:pointer;border:2px dashed #E4DCC8;border-radius:12px;overflow:hidden;min-height:120px;display:flex;align-items:center;justify-content:center}
.photo-upload-placeholder{display:flex;flex-direction:column;align-items:center;gap:8px;padding:24px;color:#9A9486;font-size:13px;font-weight:600}
.photo-preview{width:100%;height:160px;object-fit:cover;border-radius:10px}
.admin-preview-toggle{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;background:#F5F0E8;border-bottom:1px solid #E4DCC8;font-size:13px;color:#6B6659}
.toggle-btn{background:#E4DCC8;border:none;border-radius:20px;padding:5px 14px;font-size:12px;font-weight:700;color:#6B6659;cursor:pointer}
.toggle-on{background:#2D9B6F;color:#fff}
.bottom-nav{position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:1px solid #E4DCC8;display:flex;align-items:center;justify-content:space-around;padding:8px 0 20px;z-index:100;box-shadow:0 -2px 10px rgba(0,0,0,0.06)}
.bottom-nav button{display:flex;flex-direction:column;align-items:center;gap:3px;background:none;border:none;cursor:pointer;color:#9A9486;font-size:10px;font-weight:600;padding:4px 16px}
.bottom-nav button:active{color:#1B3A4B}
/* ── STARS ─── */
.stars{display:flex;gap:1px}
`;



